// Catalogo es. Generado a mano; el test de catalogos garantiza que los tres coinciden.
export default {
    'app.nombre': 'Soluxe Management',
    'app.cargando': 'Cargando...',
    'app.guardar': 'Guardar',
    'app.si': 'Sí',
    'app.no': 'No',
    'app.anadir': 'Añadir',
    'app.cancelar': 'Cancelar',
    'aj.subtitulo': 'La empresa, tu cuenta y lo que te avisa.',
    'aj.organizacion': 'Organización',
    'aj.organizacionPie': 'Identidad fiscal y domicilio',
    'aj.marca': 'Marca y apariencia',
    'aj.marcaPie': 'Colores y logotipos',
    'aj.categorias': 'Categorías de gasto',
    'aj.categoriasPie': 'El plan de gastos de la casa',
    'aj.notificaciones': 'Notificaciones',
    'aj.notificacionesPie': 'Qué te avisa en el dispositivo',
    'aj.seguridad': 'Seguridad',
    'aj.seguridadPie': 'Contraseña, llaves y segundo factor',
    'aj.integraciones': 'Integraciones',
    'aj.integracionesPie': 'Claves de servicios externos',
    'aj.apartados': 'Apartados de ajustes',
    'aj.identidad': 'Identidad',
    'aj.faltanDatos': 'Faltan datos de factura',
    'aj.identidadPie': 'El nombre comercial es el que ve tu equipo. La razón social y el NIF son los que van en la factura.',
    'aj.nombreComercial': 'Nombre comercial',
    'aj.nombreComercialPie': 'El que aparece en el menú y en los informes.',
    'aj.razonSocial': 'Razón social',
    'aj.razonSocialPie': 'El nombre registrado de la empresa.',
    'aj.nif': 'NIF / CIF',
    'aj.nifPie': 'Se guarda sin espacios ni guiones.',
    'aj.domicilio': 'Domicilio fiscal',
    'aj.domicilioPie': 'La dirección que aparecerá en las facturas que emitas.',
    'aj.direccion': 'Dirección',
    'aj.codigoPostal': 'Código postal',
    'aj.poblacion': 'Población',
    'aj.provincia': 'Provincia',
    'aj.pais': 'País',
    'aj.colores': 'Colores',
    'aj.coloresPie': 'Se aplican a la aplicación y a los documentos que genera. Los colores de estado —verde, ámbar, rojo— no cambian: dicen si algo va bien o mal, y eso no es cuestión de marca.',
    'aj.colorAcento': 'Color acento',
    'aj.colorAcentoPie': 'Botones, enlaces y resaltados',
    'aj.colorCabecera': 'Color cabecera',
    'aj.colorCabeceraPie': 'Cabecera y barra lateral',
    'aj.colorSecundario': 'Color secundario',
    'aj.colorSecundarioPie': 'Etiquetas y detalles',
    'aj.hexadecimal': '{campo} en hexadecimal',
    'aj.logotipos': 'Logotipos',
    'aj.logotiposPie': 'Uno para fondo oscuro y otro para fondo claro: el mismo logotipo no se lee bien sobre los dos.',
    'aj.sobreOscuro': 'Sobre fondo oscuro',
    'aj.sobreClaro': 'Sobre fondo claro',
    'aj.sinLogotipo': 'Sin logotipo',
    'aj.subir': 'Subir',
    'aj.cambiar': 'Cambiar',
    'aj.subiendo': 'Subiendo…',
    'aj.quitar': 'Quitar',
    'aj.vistaPrevia': 'Vista previa',
    'aj.vistaPreviaPie': 'Los cambios se ven aquí al momento. Pulsa «Guardar» para dejarlos fijos.',
    'aj.dePropiedad': 'De propiedad',
    'aj.dePropiedadPie': 'Las que se ofrecen al registrar un gasto de una casa; son las que ve el cliente en su portal.',
    'aj.internas': 'Internas',
    'aj.internasPie': 'Los gastos de la organización, los que no se repercuten a ninguna propiedad.',
    'aj.categoriasPie2': 'Añade, renombra o desactiva las categorías de tu organización. Desactivar una deja de ofrecerla al registrar; los gastos que ya la usan siguen contando.',
    'aj.sistema': 'Sistema',
    'aj.nGastos': '{total} gastos',
    'aj.unGasto': '1 gasto',
    'aj.activa': 'Activa',
    'aj.oculta': 'Oculta',
    'aj.activaAyuda': 'Se ofrece al registrar un gasto',
    'aj.ocultaAyuda': 'Oculta al registrar',
    'aj.borrar': 'Borrar',
    'aj.anadirCategoria': 'Añadir categoría',
    'aj.nombreCategoria': 'Nombre de la categoría',
    'aj.ambito': 'Ámbito de la categoría',
    'aj.nombreDe': 'Nombre de {nombre}',
    'aj.avisosPie': 'Elige qué te avisa en el dispositivo. En la campana de la aplicación siguen apareciendo todos los avisos, independientemente de esto.',
    'avisosMovil.titulo': 'Avisos en este dispositivo',
    'avisosMovil.encendido': 'Activados. Los recibirás aunque la aplicación esté cerrada.',
    'avisosMovil.apagado': 'Desactivados en este dispositivo.',
    'avisosMovil.denegado': 'El navegador los tiene bloqueados. Actívalos en los ajustes del sistema para esta aplicación.',
    'avisosMovil.noSoportado': 'Este navegador no los admite. En el iPhone: añade la aplicación a la pantalla de inicio y ábrela desde ahí.',
    'avisosMovil.sinClave': 'Todavía no están configurados en el servidor.',
    'avisosMovil.encender': 'Activar',
    'avisosMovil.apagar': 'Desactivar',
    'avisosMovil.noSePudo': 'No se han podido activar los avisos en este dispositivo.',
    'avisosMovil.instalar': 'Falta un paso: en el iPhone los avisos solo funcionan con la aplicación añadida a la pantalla de inicio.',
    'avisosMovil.paso1': 'Abre esta página en Safari y pulsa el botón Compartir (el cuadrado con la flecha hacia arriba).',
    'avisosMovil.paso2': 'Elige «Añadir a pantalla de inicio» y confirma.',
    'avisosMovil.paso3': 'Abre SOLUXE desde el icono nuevo, entra aquí otra vez y pulsa Activar.',
    'avisosMovil.ninguno': 'El servidor no tiene ningún dispositivo registrado para ti. Mientras no haya uno, no puede salir ningún aviso.',
    'avisosMovil.dispositivoSinNombre': 'Dispositivo',
    'avisosMovil.este': 'este',
    'avisosMovil.ultimo': 'Último aviso recibido el {fecha}',
    'avisosMovil.nuncaRecibio': 'Todavía no ha recibido ninguno',
    'avisosMovil.conFallos': 'fallos seguidos: {n}',
    'avisosMovil.probar': 'Enviarme una prueba',
    'avisosMovil.probando': 'Enviando…',
    'avisosMovil.entregado': 'Entregado a {dispositivo}. Si no ha sonado, míralo en Ajustes del sistema → Notificaciones → SOLUXE.',
    'avisosMovil.rechazado': '{dispositivo} lo ha rechazado ({codigo}). {motivo}',
    'aviso.CLIENTE_INCIDENCIA': 'El cliente reporta una incidencia',
    'aviso.CLIENTE_INCIDENCIAPie': 'Desde su portal, en el momento en que la escribe',
    'aviso.CLIENTE_ESTANCIA': 'El cliente avisa de su estancia',
    'aviso.CLIENTE_ESTANCIAPie': 'Cuando dice que viene, con sus fechas',
    'aviso.CLIENTE_MENSAJE': 'El cliente escribe en una incidencia',
    'aviso.CLIENTE_MENSAJEPie': 'Un mensaje suyo en la conversación, esperando respuesta',
    'aviso.INCIDENCIA_RESUELTA': 'Se cierra una incidencia',
    'aviso.INCIDENCIA_RESUELTAPie': 'Cuando alguien del equipo la da por resuelta',
    'aviso.GASTO_ALTO': 'Gasto alto',
    'aviso.INCIDENCIA_NUEVA': 'Incidencia nueva',
    'aviso.INCIDENCIA_NUEVAPie': 'Se abre una incidencia en una casa que llevas',
    'aviso.RESPUESTA_EQUIPO': 'Respuesta del equipo',
    'aviso.RESPUESTA_EQUIPOPie': 'Contestamos en la conversación de una incidencia',
    'aviso.ESTANCIA_NUEVA': 'Estancia apuntada',
    'aviso.ESTANCIA_NUEVAPie': 'Se anota una estancia en la casa',
    'aviso.GASTO_ALTOPie': 'Un gasto por encima de 100 €, con quién lo cargó',
    'aviso.ASIGNADA_A_TI': 'Te asignan una incidencia',
    'aviso.ASIGNADA_A_TIPie': 'Cuando te ponen como responsable de resolverla',
    'aviso.INCIDENCIA_CRITICA': 'Incidencias críticas',
    'aviso.INCIDENCIA_CRITICAPie': 'Cuando entra una incidencia de urgencia máxima (N1 o N2)',
    'aviso.VISITA_VENCIDA': 'Visitas vencidas',
    'aviso.VISITA_VENCIDAPie': 'Una visita programada que ya pasó sin hacerse',
    'aviso.GASTO_PENDIENTE': 'Gastos por aprobar',
    'aviso.GASTO_PENDIENTEPie': 'Gastos registrados esperando tu decisión',
    'aviso.PAGO_RECURRENTE': 'Pagos recurrentes',
    'aviso.PAGO_RECURRENTEPie': 'Cuotas y pagos que vuelven cada mes',
    'aviso.FACTURA_VENCIDA': 'Facturas vencidas',
    'aviso.FACTURA_VENCIDAPie': 'Facturas emitidas que siguen sin cobrarse',
    'aviso.MANTENIMIENTO_VENCIDO': 'Mantenimiento vencido',
    'aviso.MANTENIMIENTO_VENCIDOPie': 'Preventivos que han pasado su fecha',
    'aj.faceId': 'Llaves de acceso registradas',
    'aj.faceIdPie': 'Se entra con correo y contraseña, y el navegador las rellena por ti. Aquí quedan las llaves de acceso que registraste antes: ya no abren la sesión, y puedes quitarlas cuando quieras.',
    'aj.dispositivo': 'Dispositivo',
    'aj.anadida': 'Añadida',
    'aj.ultimoUso': 'Último uso',
    'aj.enLlavero': 'en tu llavero',
    'aj.sinLlaves': 'No tienes ninguna llave registrada.',
    'aj.porQueQuitas': '¿Por qué quitas «{nombre}»?',
    'aj.motivoLlave': 'Ya no uso ese dispositivo',
    'aj.llaveRetirada': 'Llave retirada.',
    'aj.segundoFactor': 'Segundo factor',
    'aj.activo': 'Activo',
    'aj.inactivo': 'Inactivo',
    'aj.dosFactoresActivo': 'Tu cuenta pide un código además de la contraseña.',
    'aj.dosFactoresInactivo': 'Añade una capa más a tu acceso.',
    'aj.activarDosFactores': 'Activar segundo factor',
    'aj.codigoDesactivar': 'Código para desactivar',
    'aj.desactivar': 'Desactivar',
    'aj.codigoConfirmar': 'Código de confirmación',
    'aj.confirmar': 'Confirmar',
    'aj.escanea': 'Escanéalo en tu app de autenticación (Google Authenticator, 1Password…), o introduce el secreto manualmente. Luego confirma con el código.',
    'aj.secreto': 'Secreto',
    'aj.password': 'Tu contraseña',
    'aj.passwordPie': 'Se te pide la actual porque una sesión abierta en un ordenador prestado no debería bastar para dejarte fuera de tu propia cuenta.',
    'aj.passwordActual': 'Contraseña actual',
    'aj.passwordNueva': 'Contraseña nueva',
    'aj.passwordRepetir': 'Repite la nueva',
    'aj.passwordCambiar': 'Cambiar contraseña',
    'aj.passwordCambiada': 'Contraseña cambiada.',
    'aj.passwordNoCoincide': 'Las dos contraseñas nuevas no coinciden.',
    'aj.passwordMinimo': 'Al menos 8 caracteres.',
    'auth.passwordCorta': 'La nueva contraseña es demasiado corta.',
    'auth.passwordIgual': 'La nueva contraseña es igual que la actual.',
    'auth.passwordActualMal': 'La contraseña actual no es correcta.',
    'aj.guardar': 'Guardar',
    'aj.guardando': 'Guardando…',
    'aj.guardado': 'Guardado.',
    'aj.noSeCargo': 'No se pudo cargar.',
    'aj.noSeGuardo': 'No se pudo guardar.',
    'aj.empresa': 'Empresa',
    'portal.notificarIncidencia': 'Notificar incidencia nueva',
    'portal.notificarVisita': 'Notificar visita',
    'portal.ultimaVisita': 'Última visita',
    'portal.proximaVisitaCorta': 'Próxima visita',
    'portal.sinVisitas': 'Todavía sin visitas',
    'portal.urgencia': '¿Qué urgencia tiene?',
    'portal.urgenciaPie': 'Dinos cómo lo ves. El equipo lo revisa y puede ajustarlo.',
    'portal.anadirFotos': 'Añadir fotos',
    'portal.cancelar': 'Cancelar',
    'portal.tituloIncidencia': 'Título',
    'portal.editarPie': 'Puedes corregir el título y la descripción mientras la incidencia siga abierta.',
    'portal.noSeGuardo': 'No se pudo guardar el cambio.',
    'portal.noSeSubio': 'No se pudo subir la foto.',
    'visor.cerrar': 'Cerrar',
    'visor.abrirFuera': 'Abrir aparte',
    'visor.cargando': 'Abriendo…',
    'visor.noSePudo': 'No se ha podido abrir el archivo.',
    'visor.noSeVePreview': 'Este archivo no se puede ver aquí. Ábrelo aparte para descargarlo.',
    'roto.titulo': 'Esta pantalla no se ha podido dibujar',
    'roto.explicacion': 'El resto de la aplicación sigue funcionando. Copia este detalle y mándalo: dice exactamente qué ha fallado.',
    'roto.copiar': 'Copiar el detalle',
    'roto.volver': 'Volver al panel',
    'app.volver': 'Volver',
    'app.editar': 'Editar',
    'app.confirmar': 'Confirmar',
    'app.consecuencias': 'Antes de confirmar, lee lo que implica:',
    'auth.titulo': 'Acceso',
    'auth.email': 'Correo electrónico',
    'auth.password': 'Contraseña',
    'auth.entrar': 'Entrar',
    'nav.ajustes': 'Ajustes',
    'nav.propiedades': 'Propiedades',
    'nav.panel': 'Panel',
    'integraciones.nota': 'Las claves se cifran al guardarlas y no se vuelven a mostrar nunca: aquí sólo se ve si un servicio está conectado.',
    'integraciones.conectada': 'Conectada',
    'integraciones.sinConectar': 'Sin conectar',
    'integraciones.cambiar': 'Cambiar clave',
    'integraciones.configurar': 'Configurar',
    'integraciones.desconectar': 'Desconectar',
    'integraciones.clave': 'Clave / token (secreto)',
    'integraciones.clavePista': 'Se cifra al guardar; nunca se vuelve a mostrar',
    'integraciones.etiqueta': 'Etiqueta (opcional)',
    'nav.mas': 'Más',
    'auth.salir': 'Cerrar sesión',
    'auth.error.credenciales': 'El correo o la contraseña no son correctos.',
    'auth.error.demasiadosIntentos': 'Demasiados intentos seguidos. Espera unos minutos y vuelve a probar.',
    'auth.error.sesionExpirada': 'Tu sesión ha caducado. Vuelve a entrar.',
    'auth.error.segundoFactor': 'El código de verificación no es correcto.',
    'error.sinPermiso': 'No tienes permiso para ver esto.',
    'error.gastoFacturado': 'Este gasto ya está en una factura: no se puede cambiar ni quitar. Rectifica la factura.',
    'error.responsableNoValido': 'Esa persona no puede encargarse: tiene que ser del equipo y estar activa.',
    'error.responsableSinAcceso': 'Esa persona no tiene esta casa asignada. Asígnasela en Usuarios y vuelve a intentarlo.',
    'inc.responsable': 'Responsable',
    'inc.titulo': 'Título',
    'inc.descripcion': 'Descripción',
    'inc.sinResponsable': 'Sin responsable',
    'inc.elegirResponsable': 'Elegir responsable…',
    'inc.responsableNota': 'Le sale en su «Tareas del día» mientras la incidencia siga abierta.',
    'inc.sinAccesoCasa': 'sin acceso a esta casa',
    'dia.asignada': 'Asignada',
    'error.noEncontrado': 'No se ha encontrado.',
    'error.validacion': 'Revisa los datos introducidos.',
    'error.servidor': 'Ha ocurrido un error. Vuelve a intentarlo.',
    'error.configuracion': 'Esta función no está configurada todavía.',
    'referido.estadoInvalido': 'El referido no está en un estado que permita esta acción.',
    'propiedades.titulo': 'Propiedades',
    'propiedades.vacio': 'Todavía no hay propiedades.',
    'propiedades.codigo': 'Código',
    'propiedades.nombre': 'Nombre',
    'propiedades.zona': 'Zona',
    'propiedades.estado': 'Estado',
    'propiedades.propietarios': 'Propietarios',
    'propiedades.nio': 'Nivel operativo',
    'propiedades.semaforo': 'Estado operativo',
    'propiedades.requisitos': 'Requisitos pendientes',
    'propiedades.sinRequisitos': 'Lista para activar',
    'propiedades.impideActivacion': 'Falta esto para poder activarla:',
    'propiedades.activar': 'Activar propiedad',
    'propiedades.demoExcluida': 'excluida de métricas y de cualquier operación real.',
    'propiedades.historial': 'Historial',
    'propiedades.relaciones': 'Personas y empresas',
    'propiedades.contrato': 'Contrato',
    'propiedades.incidencias': 'Incidencias',
    'cartera.resumen': '{total} en total · {atencion} requieren atención',
    'cartera.buscar': 'Buscar por código, nombre o zona',
    'cartera.ordenar': 'Ordenar',
    'cartera.ordenEstado': 'Por estado',
    'cartera.ordenNombre': 'Por nombre',
    'cartera.ordenCodigo': 'Por código',
    'cartera.verLista': 'Ver en lista',
    'cartera.verTarjetas': 'Ver en tarjetas',
    'cartera.sinTitular': 'Sin titular',
    'cartera.sinResultados': 'No hay propiedades que coincidan con la búsqueda.',
    'cartera.limpiar': 'Limpiar búsqueda',
    'cartera.activas': '{total} activas',
    'cartera.incidenciasAbiertas': 'Incidencias abiertas',
    'cartera.nueva': 'Nueva propiedad',
    'proveedores.titulo': 'Proveedores',
    'proveedores.resumen': '{total} activos',
    'proveedores.nuevo': 'Nuevo proveedor',
    'proveedores.vacio': 'Todavía no hay proveedores en el directorio.',
    'proveedores.nombre': 'Nombre',
    'proveedores.oficio': 'Oficio',
    'proveedores.email': 'Correo electrónico',
    'proveedores.telefono': 'Teléfono',
    'proveedores.nif': 'NIF',
    'proveedores.zona': 'Zona',
    'proveedores.notas': 'Notas',
    'proveedores.guardar': 'Guardar proveedor',
    'proveedores.cancelar': 'Cancelar',
    'proveedores.archivar': 'Archivar',
    'proveedores.reactivar': 'Reactivar',
    'proveedores.archivado': 'Archivado',
    'proveedores.verArchivados': 'Ver archivados',
    'proveedores.todos': 'Todos los oficios',
    'proveedores.sinContacto': 'Sin contacto',
    'oficio.FONTANERIA': 'Fontanería',
    'oficio.JARDINERIA': 'Jardinería',
    'oficio.CLIMA': 'Clima y frío',
    'oficio.PISCINAS': 'Piscinas',
    'oficio.LIMPIEZA': 'Limpieza',
    'oficio.ELECTRICIDAD': 'Electricidad',
    'oficio.OBRA': 'Obra y albañilería',
    'oficio.SEGURIDAD': 'Seguridad',
    'oficio.OTRO': 'Otro',
    'calendario.titulo': 'Calendario',
    'calendario.mes': 'Mes',
    'calendario.anterior': 'Mes anterior',
    'calendario.siguiente': 'Mes siguiente',
    'calendario.hoy': 'Hoy',
    'calendario.todas': 'Todas las propiedades',
    'calendario.nuevo': 'Nuevo evento',
    'calendario.sinEventos': 'No hay eventos este mes.',
    'calendario.mas': '+{total} más',
    'evento.VISITA': 'Visita',
    'evento.PREVENTIVA': 'Mantenimiento',
    'evento.REVISION': 'Revisión',
    'evento.LLEGADA': 'Llegada',
    'evento.SALIDA': 'Salida',
    'evento.OTRO': 'Otro',
    'evento.tipo': 'Tipo',
    'evento.titulo': 'Título',
    'evento.fecha': 'Fecha',
    'evento.hora': 'Hora',
    'evento.propiedad': 'Propiedad',
    'evento.asignado': 'Asignado a',
    'evento.notas': 'Notas',
    'evento.sinPropiedad': 'Sin propiedad',
    'evento.sinAsignar': 'Sin asignar',
    'evento.guardar': 'Guardar evento',
    'evento.marcarHecha': 'Marcar como hecha',
    'evento.marcarCancelada': 'Cancelar evento',
    'evento.reabrir': 'Reabrir',
    'evento.cerrar': 'Cerrar',
    'evento.irPropiedad': 'Ver la propiedad',
    'checklists.titulo': 'Plantillas de checklist',
    'checklists.resumen': '{total} plantillas',
    'checklists.nuevaPlantilla': 'Nueva plantilla',
    'checklists.sinPlantillas': 'Todavía no hay plantillas.',
    'checklists.elige': 'Elige una plantilla para ver sus ítems.',
    'checklists.itemsCorto': 'ítems',
    'checklists.criticos': 'Críticos',
    'checklists.critico': 'Crítico',
    'checklists.foto': 'Foto',
    'checklists.anadirItem': 'Añadir ítem',
    'checklists.seccion': 'Sección',
    'checklists.texto': 'Texto del ítem',
    'checklists.guardar': 'Guardar',
    'checklists.cancelar': 'Cancelar',
    'checklists.archivar': 'Archivar',
    'checklists.reactivar': 'Reactivar',
    'checklists.archivada': 'Archivada',
    'checklists.eliminar': 'Eliminar',
    'checklists.editar': 'Editar',
    'checklists.nombre': 'Nombre',
    'checklists.tipo': 'Tipo',
    'checklists.sinItems': 'Esta plantilla no tiene ítems todavía.',
    'checklistTipo.ENTRADA': 'Entrada',
    'checklistTipo.SALIDA': 'Salida',
    'checklistTipo.PERIODICA': 'Revisión periódica',
    'checklistTipo.MANTENIMIENTO': 'Mantenimiento',
    'checklistTipo.OTRO': 'Otro',
    'alertas.titulo': 'Notificaciones',
    'alertas.marcarLeidas': 'Marcar como leídas',
    'alertas.sinLeer': '{total} sin ver',
    'alertas.resumen': '{total} requieren tu atención',
    'alertas.vacio': 'Todo al día. No hay alertas.',
    'alertas.incidencia': 'Incidencia abierta',
    'alertas.activacion': 'Activación pendiente',
    'alertas.requisitos': '{total} requisitos pendientes',
    'alertaSeveridad.ALTA': 'Alta',
    'alertaSeveridad.MEDIA': 'Media',
    'alertaSeveridad.BAJA': 'Baja',
    'mapa.titulo': 'Mapa de actividad',
    'mapa.subtitulo': 'Dónde está la cartera y qué reclama atención',
    'mapa.zona': 'Zona',
    'mapa.todas': 'Todas las zonas',
    'mapa.esquema': 'Esquema ilustrativo: las posiciones no son geográficas.',
    'mapa.actividad': 'Propiedades con incidencias abiertas',
    'mapa.sinActividad': 'No hay incidencias abiertas en la selección.',
    'mapa.incidencias': '{total} abiertas',
    'adjunto.noSeGuarda': 'No se ha podido guardar el fichero en el servidor.',
    'ficha.subiendoFoto': 'Subiendo la foto...',
    'ficha.subirFoto': 'Elegir una foto (JPEG, PNG o WEBP)',
    'ficha.subirFotoAyuda': 'Se guarda en el sistema. Al quitar la foto se borra tambien el fichero.',
    'ficha.anadirPorUrl': 'Anadir por direccion',
    'cobro.titulo': 'Cobro',
    'cobro.POR_COBRAR': 'Por cobrar',
    'cobro.FACTURADO': 'Facturado',
    'cobro.COBRADO': 'Cobrado',
    'adjunto.contenidoPerdido': 'El fichero ya no esta en el almacen.',
    'inc.fotoNoSeVe': 'No se puede mostrar. Abrir o descargar',
    'interno.buscar': 'Buscar concepto, persona o descripcion',
    'interno.todoElEquipo': 'Todo el equipo',
    'interno.todoElHistorico': 'Todo el historico',
    'interno.meses': 'Meses',
    'interno.limpiar': 'Quitar filtros',
    'interno.importeDesde': 'Importe desde',
    'interno.importeHasta': 'Importe hasta',
    'interno.descargarExcel': 'Descargar Excel',
    'interno.horasTitulo': 'Horas del equipo',
    'llaves.noEntra': 'No se ha podido entrar con la llave. Prueba con tu contrasena.',
    'llaves.desafioInvalido': 'La peticion ha caducado. Vuelve a intentarlo.',
    'llaves.noVerificada': 'No se ha podido comprobar la llave.',
    'llaves.desconocida': 'Esa llave no esta dada de alta.',
    'llaves.clonada': 'La llave no supera la comprobacion de seguridad. Retirala y crea una nueva.',
    'import.carteraConDatos': 'La cartera ya tiene propiedades: la instantánea de arranque solo entra una vez, y ya entró.',
    'import.checkTitulo': 'Plantillas de checklist',
    'import.checkIntro': 'Trae las plantillas de visita del gestor anterior. Se reconocen por su nombre: repetirlo no duplica nada, solo añade los items que falten.',
    'import.checkPlantillas': 'Plantillas',
    'import.checkItems': 'Items',
    'import.proyTitulo': 'Proyectos y tareas',
    'import.proyIntro': 'Trae los proyectos del gestor anterior. Se puede lanzar más de una vez: lo que ya está se reconoce y no se duplica.',
    'import.proyEquipos': 'Equipos',
    'import.proyProyectos': 'Proyectos',
    'import.proySecciones': 'Secciones',
    'import.proyTareas': 'Tareas',
    'import.proySubtareas': 'Subtareas',
    'import.proyAsignaciones': 'Responsables asignados',
    'import.proyEtiquetas': 'Etiquetas',
    'import.proyYaEstaban': 'Ya estaban (no se duplicaron)',
    'import.proySinResolver': 'Personas del fichero que no están en el equipo',
    'import.titulo': 'Importar datos de arranque',
    'import.intro': 'Entra de una vez la historia que la empresa ya tenía: sus casas, sus incidencias, sus gastos y las horas de su equipo. Solo se puede hacer sobre una cartera vacía, y o entra entero o no entra nada.',
    'import.fichero': 'Fichero de la instantanea (.json)',
    'import.password': 'Contraseña inicial del equipo',
    'import.passwordNota': 'Se la damos a las personas que se creen. Cada una la cambia al entrar; dirección puede restablecerla desde Usuarios.',
    'import.importar': 'Importar',
    'import.importando': 'Importando…',
    'import.hecho': 'Datos importados',
    'import.ficheroInvalido': 'Ese fichero no es una instantanea valida.',
    'import.deshabilitada': 'La importación no esta habilitada en esta instalacion.',
    'import.carteraNoVacia': 'La cartera ya tiene propiedades: importar ahora las duplicaria.',
    'import.usuariosCreados': 'Personas creadas',
    'import.usuariosReutilizados': 'Personas que ya existian',
    'import.propiedades': 'Propiedades',
    'import.proveedores': 'Proveedores',
    'import.gastos': 'Gastos',
    'import.horas': 'Horas',
    'import.incidencias': 'Incidencias',
    'import.eventos': 'Eventos de agenda',
    'import.mantenimiento': 'Mantenimientos',
    'import.estancias': 'Estancias',
    'import.documentos': 'Documentos',
    'import.historial': 'Entradas de historial',
    'area.INTERIOR': 'Interior',
    'area.EXTERIOR': 'Exterior',
    'area.SISTEMAS': 'Sistemas',
    'area.PISCINA': 'Piscina',
    'area.JARDIN': 'Jardín',
    'area.GESTION': 'Gestión',
    'area.OTRO': 'Otro',
    'prov.hola': 'Hola, {nombre}',
    'prov.misEncargos': 'Mis encargos',
    'prov.resumen': '{total} trabajos abiertos',
    'prov.sinEncargos': 'No tienes ningun encargo abierto.',
    'prov.historico': 'Cerrados ({total})',
    'prov.instrucciones': 'Instrucciones',
    'prov.aceptar': 'Aceptar el encargo',
    'prov.rechazar': 'Rechazar',
    'prov.iniciar': 'Empezar el trabajo',
    'prov.solicitarFin': 'Solicitar cierre',
    'prov.esperandoCierre': 'Pendiente de que lo den por bueno',
    'prov.presupuestar': 'Presupuestar',
    'prov.enviarPresupuesto': 'Enviar presupuesto',
    'prov.tuPresupuesto': 'Tu presupuesto',
    'prov.queIncluye': 'Qué incluye',
    'prov.porQue': 'Por qué no lo tomas?',
    'prov.porQueNota': 'Sin el motivo, el equipo tendria que llamarte para saber que ha pasado.',
    'prov.motivoRechazo': 'Motivo del rechazo',
    'encargo.ASIGNADO': 'Asignado',
    'encargo.ACEPTADO': 'Aceptado',
    'encargo.EN_CURSO': 'En curso',
    'encargo.FIN_SOLICITADA': 'Cierre solicitado',
    'encargo.COMPLETADO': 'Completado',
    'encargo.RECHAZADO': 'Rechazado',
    'encargo.sinProveedor': 'Tu usuario no está vinculado a ninguna empresa proveedora.',
    'encargo.estadoInvalido': 'El encargo no admite esa accion en su estado.',
    'encargo.proveedorInactivo': 'Ese proveedor está archivado.',
    'encargo.encargar': 'Encargar a un proveedor',
    'encargo.encargos': 'Encargos',
    'proyecto.sinMiembros': 'Todavía no hay nadie en este proyecto.',
    'proyecto.sinCandidatos': 'No queda nadie del equipo por añadir.',
    'proyecto.responsable': 'Responsable',
    'equipo.vincularPropiedad': 'Vincular propiedad',
    'equipo.titulo': 'Usuarios',
    'equipo.resumen': '{total} usuarios en el sistema',
    'equipo.nuevo': 'Nuevo usuario',
    'equipo.crear': 'Crear usuario',
    'equipo.buscar': 'Buscar por nombre o email...',
    'equipo.sinResultados': 'Nadie coincide con esa búsqueda.',
    'equipo.filtroTODOS': 'Todos',
    'equipo.filtroEQUIPO': 'Equipo',
    'equipo.filtroCLIENTES': 'Clientes',
    'equipo.filtroOCULTOS': 'Ocultos',
    'equipo.nProp': '{total} prop.',
    'equipo.oculto': 'Oculto',
    'equipo.activo': 'Activo',
    'equipo.informacion': 'Información',
    'equipo.propiedades': 'Propiedades',
    'equipo.nombreCompleto': 'Nombre completo',
    'equipo.nombrePista': 'Ej. Manuel García',
    'equipo.claveInicial': 'Contraseña inicial',
    'equipo.claveMinimo': 'Mínimo 8 caracteres',
    'equipo.claveNueva': 'Nueva contraseña (mín. 8)',
    'equipo.idioma': 'Idioma',
    'equipo.rolSistema': 'Rol del sistema',
    'equipo.rolAyuda': 'Decide a qué datos llega. No es su oficio.',
    'equipo.rolInmediato': 'El cambio de rol es inmediato: la persona necesita volver a entrar para que tome efecto.',
    'equipo.accesoCrm': 'Acceso al CRM',
    'equipo.accesoCrmAyuda': 'El CRM enseña con quién se está hablando, por cuánto y en qué punto. Se concede persona a persona.',
    'equipo.crmSi': 'Con acceso',
    'equipo.crmNo': 'Sin acceso',
    'equipo.funcion': 'Función en la empresa',
    'equipo.funcionAyuda': 'A qué se dedica. No cambia lo que ve.',
    'equipo.guardarCambios': 'Guardar cambios',
    'equipo.guardar': 'Guardar',
    'equipo.guardado': 'Guardado.',
    'equipo.restablecerClave': 'Restablecer contraseña',
    'equipo.claveCambiada': 'Contraseña cambiada.',
    'equipo.claveCierraSesiones': 'Al cambiarla se cierran todas sus sesiones abiertas.',
    'equipo.ocultarUsuario': 'Ocultar usuario',
    'equipo.eliminarUsuario': 'Eliminar usuario',
    'equipo.reactivar': 'Reactivar usuario',
    'equipo.tieneHistoricoNota': 'Esta persona ya registró trabajo, así que no se borra: se oculta y su histórico se conserva.',
    'equipo.sinHistoricoNota': 'Nunca registró trabajo, así que se puede eliminar sin dejar nada huérfano.',
    'equipo.sinPropiedades': 'Sin propiedades asignadas.',
    'equipo.asignarPropiedad': 'Asignar propiedad',
    'equipo.buscarPropiedad': 'Buscar por nombre o código...',
    'equipo.sinCandidatas': 'No queda ninguna propiedad por asignar.',
    'equipo.rolEnPropiedad': 'Rol en la propiedad',
    'equipo.retirar': 'Retirar',
    'equipo.emailDuplicado': 'Ese correo ya está en uso.',
    'equipo.ultimoDirector': 'La empresa se quedaría sin dirección.',
    'equipo.noATiMismo': 'No puedes hacerte eso a ti mismo.',
    'equipo.tieneHistorico': 'Esa persona ya registró trabajo: se oculta, no se borra.',
    'equipo.clienteVaPorParty': 'A un propietario se le vincula la propiedad desde su ficha de persona, porque ese vínculo sostiene la facturación.',
    'equipo.inactivo': 'Esa persona está desactivada.',
    'asignacion.PRINCIPAL': 'Principal',
    'asignacion.SECUNDARIO': 'Secundario',
    'asignacion.OWNER': 'Propietario',
    'asignacion.PROMOTER': 'Promotora',
    'asignacion.ASSET_MANAGER': 'Asset manager',
    'asignacion.AUTHORIZED_CONTACT': 'Contacto autorizado',
    'funcion.DIRECCION': 'Dirección',
    'funcion.MANAGER': 'Manager',
    'funcion.MARKETING': 'Marketing',
    'funcion.REAL_ESTATE': 'Real Estate',
    'funcion.MANTENIMIENTO': 'Mantenimiento',
    'funcion.JARDINERIA': 'Jardinería',
    'funcion.LIMPIEZA': 'Limpieza',
    'funcion.ADMINISTRACION': 'Administración',
    'funcion.OTRA': 'Otra',
    'proyecto.soloEquipo': 'A un proyecto interno sólo entra gente del equipo.',
    'proyecto.miembros': 'Miembros',
    'proyecto.anadirMiembro': 'Añadir al proyecto',
    'contacto.intro': 'Cómo llegar hasta nosotros y las dudas que más se repiten.',
    'contacto.comoEscribir': 'Cómo escribirnos',
    'contacto.reportarPie': 'Desde tu portal. Lo vemos el mismo día y te decimos la urgencia.',
    'contacto.responderHilo': 'Responder en la incidencia',
    'contacto.responderHiloPie': 'Abre cualquier incidencia y escribe: el mensaje llega a quien la lleva.',
    'contacto.faq': 'Preguntas frecuentes',
    'contacto.p.semaforo': 'Qué significa el estado de mi propiedad?',
    'contacto.r.semaforo': 'Verde es que está al día. Amarillo es que hay algo abierto que no corre prisa. Rojo es que hay algo que reclama atención ahora, y en ese caso ya estamos encima.',
    'contacto.p.idiomaClave': 'Cómo cambio el idioma o mi contraseña?',
    'contacto.r.idiomaClave': 'El idioma se cambia abajo a la izquierda, en cualquier momento. La contraseña se cambia desde Configuración.',
    'contacto.p.reportar': 'Cómo reporto algo?',
    'contacto.r.reportar': 'Con el botón de reportar de tu portal. Cuenta lo que ves con tus palabras: la urgencia técnica la ponemos nosotros al revisarlo.',
    'contacto.p.informe': 'Dónde veo lo que se ha hecho en mi casa?',
    'contacto.r.informe': 'En Mis incidencias tienes cada intervención con sus fotos y su conversación. Lo que aparece ahí es lo que el equipo ha compartido contigo.',
    'cartera.resumenAsignadas': '{total} asignadas · {atencion} requieren atención',
    'panel.miPanel': 'Mi Panel',
    'portal.buenosDias': 'Buenos días, {nombre}',
    'portal.buenasTardes': 'Buenas tardes, {nombre}',
    'portal.buenasNoches': 'Buenas noches, {nombre}',
    'portal.tusPropiedades': 'Tus propiedades',
    'portal.misPropiedades': 'Mis propiedades',
    'portal.sinPropiedades': 'Todavía no tienes ninguna propiedad asignada.',
    'portal.visitasAnio': 'Visitas este año',
    'portal.incidenciasAbiertas': 'Incidencias abiertas',
    'portal.enCurso': 'en curso',
    'portal.alCorriente': 'Al corriente de pago',
    'portal.proximaVisita': 'Tu próxima visita: {fecha}',
    'portal.misIncidencias': 'Mis incidencias',
    'portal.sinIncidencias': 'No hay nada abierto ahora mismo.',
    'portal.filtroABIERTAS': 'Abiertas',
    'portal.filtroRESUELTAS': 'Resueltas',
    'portal.filtroTODAS': 'Todas',
    'portal.sinEnEsteFiltro': 'No hay ninguna aquí.',
    'portal.abierta': 'Abierta',
    'portal.resuelta': 'Resuelta',
    'portal.resumen': 'Resumen de tu propiedad',
    'portal.resumenPie': 'Redactado automáticamente a partir de los datos que ves en esta página.',
    'portal.resumenNoDisponible': 'El resumen automático no está disponible ahora mismo.',
    'portal.fotos': 'Fotos',
    'portal.mensajes': 'Mensajes',
    'portal.sinMensajes': 'Aún no hay mensajes. Escribe si tienes alguna duda.',
    'portal.escribeMensaje': 'Escribe un mensaje...',
    'portal.enviar': 'Enviar',
    'portal.tuEstancia': 'Tu estancia',
    'portal.sinEstancias': 'No hay ninguna estancia avisada.',
    'portal.avisarLlegada': 'Avisar de mi llegada',
    'portal.llegada': 'Llegada',
    'portal.salida': 'Salida (opcional)',
    'portal.estanciaNota': 'Con esto evitamos programarte una visita mientras estás en la casa.',
    'portal.reportar': 'Reportar una incidencia',
    'portal.queOcurre': 'Qué ocurre?',
    'portal.queOcurrePista': 'Por ejemplo: gotea el grifo de la cocina',
    'portal.detalles': 'Detalles (opcional)',
    'portal.reportarNota': 'La revisamos y te decimos la urgencia y los pasos.',
    'portal.facturacion': 'Datos de facturación',
    'portal.documentos': 'Documentos de tu casa',
    'portal.sinDocumentos': 'Todavía no hay documentos compartidos.',
    'ficha.verDueno': 'Lo ve el dueño',
    'portal.facturacionPie': 'Añade tus datos para que aparezcan en la factura.',
    'portal.facturacionCampo': 'Nombre fiscal, NIF y dirección',
    'portal.facturacionPista': 'Nombre o razón social\nNIF\nDirección completa',
    'portal.editar': 'Editar',
    'portal.guardar': 'Guardar',
    'portal.contacto': 'Contacto',
    'portal.ajustes': 'Configuración',
    'rapido.fecha': 'Fecha',
    'rapido.importe': 'Importe',
    'rapido.queEs': 'Qué',
    'rapido.titulo': 'Qué quieres registrar?',
    'rapido.gasto': 'Un gasto',
    'rapido.horas': 'Horas de trabajo',
    'rapido.horasPie': 'Tiempo dedicado',
    'rapido.comprobante': 'Comprobante',
    'rapido.fotoObligatoria': 'La foto del ticket o la factura es obligatoria: sin ella el gasto no se puede justificar.',
    'rapido.hacerFoto': 'Hacer foto o elegir fichero',
    'rapido.formatosFoto': 'Imagen o PDF',
    'rapido.deQuienSon': 'De quién es el trabajo?',
    'rapido.deQuienSonPie': 'Dirección puede imputar el trabajo de quien no usa la aplicación.',
    'rapido.mias': 'Mías',
    'rapido.paraQuien': 'Para quién es?',
    'rapido.cliente': 'De un cliente',
    'rapido.clientePie': 'Va a una propiedad',
    'rapido.interno': 'Interno',
    'rapido.internoPie': 'De la empresa, sin propiedad',
    'rapido.queCliente': 'De qué propiedad?',
    'rapido.vinculado': 'Va con alguna incidencia abierta?',
    'rapido.aislado': 'Sin incidencia',
    'error.gastoDeHoras': 'Esta línea sale de una carga de horas: sus horas y precios se corrigen desde «Editar» con las horas; aquí solo cambia la descripción.',
    'categoriaGasto.MANO_DE_OBRA': 'Mano de obra',
    'rapido.otraPersona': 'Otro: escribir manualmente',
    'rapido.otraPersonaPie': 'Un proveedor o alguien que no usa la app',
    'rapido.nombrePersona': 'Nombre de la persona o proveedor',
    'rapido.vinculadoPie': 'Marca una o varias, añade una descripción, o las dos cosas.',
    'rapido.descripcionManual': 'Descripción manual',
    'rapido.descripcionManualPie': 'Escribe qué se hizo',
    'rapido.queSeHizo': '¿Qué se hizo?',
    'rapido.continuar': 'Continuar',
    'rapido.costeYPrecio': 'Coste y precio de la hora',
    'rapido.costeYPrecioPie': 'Viene de las tarifas del equipo. Puedes cambiarlo solo para este trabajo.',
    'rapido.costeHora': 'Coste hora (€)',
    'rapido.precioHora': 'Precio hora para el cliente (€)',
    'rapido.facturableExtra': '¿Facturable extra?',
    'rapido.extraSi': 'Sale en los gastos de la casa y se cobra al cliente',
    'rapido.extraNo': 'Coste interno: incluido en el fee, el cliente ve 0 €',
    'rapido.costeHoraInvalido': 'Indica el coste por hora (puede ser 0).',
    'rapido.precioHoraInvalido': 'Para cobrarlo aparte, indica el precio por hora para el cliente.',
    'gastos.descripcion': 'Descripción',
    'gastos.descripcionPlaceholder': 'Qué se hizo…',
    'gastos.incidencias': 'Incidencias asociadas',
    'gastos.sinIncidenciasAbiertas': 'Esta casa no tiene incidencias abiertas.',
    'gastos.incluidoEnFee': 'Incluido en el fee',
    'ficha.precioParaCliente': 'Precio para el cliente',
    'ficha.editarTarifa': 'Editar tarifa',
    'ficha.tarifaPrecioPie': 'Pulsa un importe para cambiarlo. EUR/hora y precio para el cliente se proponen al cargar horas en esta casa.',
    'finreg.precioCliente': 'Precio cliente/hora',
    'rapido.queTrabajo': 'Qué clase de trabajo?',
    'rapido.queTrabajoPie': 'Decide en qué concepto entran estas horas.',
    'rapido.queCategoria': 'Qué clase de gasto?',
    'rapido.cuantasHoras': 'Cuánto tiempo?',
    'rapido.cuanto': 'De cuánto?',
    'rapido.tiempoManual': 'O escribe el tiempo',
    'rapido.tiempoManualPie': 'Admite 45 · 1,5 · 1:45 (horas:minutos)',
    'rapido.tiempoInvalido': 'No se entiende ese tiempo. Prueba con 45, 1,5 o 1:45 (hasta 744 h).',
    'rapido.tiempoEjemplo': '1,45',
    'rapido.importeManual': 'O escribe el importe',
    'rapido.repercutible': 'Se le repercute al cliente?',
    'rapido.repercutiblePie': 'Si se repercute, entra en la próxima factura de la propiedad.',
    'rapido.entraEnFactura': 'Entra en su factura',
    'rapido.loAsumimos': 'Lo asume la gestora',
    'rapido.si': 'Sí',
    'rapido.no': 'No',
    'rapido.cuando': 'Qué día?',
    'rapido.hoy': 'Hoy',
    'rapido.ayer': 'Ayer',
    'rapido.fechaInvalida': 'Escribe la fecha entera (día, mes y año). No puede ser futura ni anterior al 2000.',
    'rapido.otraFecha': 'Otra fecha',
    'rapido.revisar': 'Revisa antes de enviar',
    'rapido.notaOpcional': 'Nota (opcional)',
    'rapido.enviar': 'Enviar',
    'rapido.enviado': 'Registrado.',
    'rapido.otroMas': 'Cargar otro',
    'rapido.verCargado': 'Volver',
    'rapido.atras': 'Atrás',
    'rapido.confirmar': 'Confirmar',
    'rapido.toques': 'Paso {n} de {total}',
    'nav.registrar': 'Registrar',
    'inc.fotoOcultaAyuda': 'Solo la ve el equipo. Pulsa para compartirla con el propietario.',
    'inc.fotoVisibleAyuda': 'El propietario la ve. Pulsa para dejar de compartirla.',
    'factura.titulo': 'Facturas',
    'factura.crear': 'Facturar pendiente',
    'factura.sinFacturas': 'Sin facturas todavía.',
    'factura.emitir': 'Emitir',
    'factura.cobrar': 'Marcar cobrada',
    'factura.vencidaDias': 'vencida {total}d',
    'factura.estadoBORRADOR': 'Borrador',
    'factura.estadoEMITIDA': 'Emitida',
    'factura.estadoCOBRADA': 'Cobrada',
    'factura.estadoANULADA': 'Anulada',
    'factura.sinPendiente': 'No hay gastos repercutibles pendientes de facturar.',
    'factura.estadoInvalido': 'La factura no permite esa accion en su estado.',
    'anomalia.titulo': 'Anomalías de gasto',
    'anomalia.total': '{total} anomalías',
    'anomalia.metodo': 'Detectadas con mediana y desviacion absoluta: un solo gasto muy alto no puede esconderse a sí mismo.',
    'severidad.ALTA': 'Alta',
    'severidad.MEDIA': 'Media',
    'severidad.BAJA': 'Baja',
    'visita.empezarLista': 'Empezar la lista',
    'visita.continuarLista': 'Continuar la lista',
    'visita.verLista': 'Ver la lista',
    'visita.desdeAgenda': 'Desde la agenda: {titulo}',
    'visita.deLaAgenda': 'De la agenda',
    'visita.iniciar': 'Iniciar visita',
    'visita.plantilla': 'Desde plantilla',
    'visita.editar': 'Editar la visita',
    'visita.anadirNota': 'Añadir una nota',
    'visita.motivo': 'Motivo de la visita',
    'visita.descartar': 'Salir y descartar',
    'visita.confirmarDescartar': '¿Salir sin cerrar la visita? Se pierde lo que llevas marcado y la visita se da por no hecha.',
    'visita.enCursoAviso': 'Tienes una visita empezada. Ábrela para terminarla o descartarla.',
    'visita.realizadas': 'Visitas realizadas',
    'visita.programadas': 'Visitas programadas',
    'visita.continuarVisita': 'Seguir con la visita',
    'visita.verVisita': 'Ver la visita',
    'visita.motivoOpcional': 'Motivo de la visita (opcional)',
    'visita.motivoPie': 'Para qué se va: qué hay que mirar, qué pidió el cliente',
    'visita.porMotivo': 'Sin lista · por un motivo concreto',
    'visita.detalle': 'Detalle (opcional)',
    'visita.notaPie': 'Qué se encontró, qué se hizo',
    'visita.notaVisita': 'Nota de la visita',
    'visita.quitarFoto': 'Quitar la foto',
    'visita.confirmarQuitarFoto': '¿Quitar esta foto? No se puede deshacer.',
    'visita.elegirPlantilla': 'Elegir una lista…',
    'visita.resumenPlegado': '{hechos} de {total} puntos · {fotos} fotos',
    'visita.plegar': '← Cerrar esta visita',
    'evento.sinTitulo': 'Elige una lista para la visita.',
    'visita.sinPlantilla': 'Sin plantilla (visita libre)',
    'visita.copiaNota': 'Los items se copian al iniciar: editar la plantilla después no cambia esta visita.',
    'visita.sinItems': 'Esta visita no tiene lista de comprobación.',
    'visita.pendientes': '{total} sin marcar',
    'visita.completar': 'Completar visita',
    'visita.abrira': 'abrira {total} incidencias',
    'visita.completadaCon': 'Visita completada. Se han abierto {total} incidencias.',
    'visita.completadaSin': 'Visita completada sin incidencias.',
    'visita.estadoEN_CURSO': 'En curso',
    'visita.estadoCOMPLETADA': 'Completada',
    'visita.estadoABANDONADA': 'Abandonada',
    'visita.resOK': 'OK',
    'visita.resINCIDENCIA': 'Incidencia',
    'visita.resNO_APLICA': 'No aplica',
    'visita.resPENDIENTE': 'Pendiente',
    'visita.estadoInvalido': 'La visita ya esta cerrada.',
    'panel.facturasPorCobrar': 'Facturas por cobrar',
    'panel.emitidaEl': 'Emitida el {fecha}',
    'panel.rendimientoEquipo': 'Rendimiento del equipo',
    'panel.cumplimientoNota': 'Visitas completadas frente a las agendadas en el mes.',
    'panel.agendadas': 'Agendadas',
    'panel.completadas': 'Completadas',
    'panel.cumplimiento': 'Cumplimiento',
    'panel.sinAgenda': 'sin agenda',
    'panel.informeCartera': 'Informe mensual',
    'mio.horas': 'Horas del mes',
    'mio.horasPie': 'en {total} partes de trabajo',
    'mio.gastos': 'Gastos del mes',
    'mio.gastosPie': '{total} registrados',
    'mio.aCobrar': 'A cobrar hasta hoy',
    'mio.aCobrarPie': 'por las horas registradas, con la tarifa de cada casa',
    'mio.incidencias': 'Incidencias en mis casas',
    'mio.incidenciasPie': '{n1} urgentes · {n2} prioritarias',
    'mio.ocupacion': 'Casas ocupadas',
    'mio.ocupacionPie': 'de las que gestiono',
    'mio.proximasVisitas': 'Próximas visitas',
    'mio.sinVisitas': 'No hay ninguna visita programada.',
    'mio.informe': 'Mi informe del mes',
    'mio.informeNota': 'Tus horas, tus visitas, las incidencias que has resuelto y el cálculo de pago.',
    'panel.hola': 'Hola, {nombre}',
    'panel.margenMes': 'Margen del mes',
    'panel.margenPie': 'facturable menos coste',
    'panel.costeSoportado': 'Coste soportado',
    'panel.costePie': 'adelantado por la gestora',
    'panel.facturable': 'Facturable a clientes',
    'panel.facturablePie': 'coste más margen',
    'panel.gastoInterno': 'Gasto interno',
    'panel.gastoInternoPie': 'organización, este mes',
    'panel.clientes': 'Clientes',
    'panel.incidenciasCriticas': 'Incidencias críticas',
    'panel.deAbiertas': 'de {total} abiertas',
    'panel.horasMes': 'Horas del mes',
    'panel.horasPie': 'registradas sobre propiedades',
    'panel.pendienteFacturar': 'Pendiente de facturar',
    'panel.pendienteFacturarNota': 'Trabajo aprobado y repercutible que aún no se ha facturado.',
    'panel.nGastos': '{total} gastos',
    'panel.esperando': 'esperando {total}d',
    'panel.incidenciasActivas': 'Incidencias activas',
    'panel.total': '{total} total',
    'panel.criticasAbiertas': 'Incidencias críticas abiertas',
    'panel.resumenPropiedades': 'Resumen de propiedades',
    'panel.propiedad': 'Propiedad',
    'panel.ocupacion': 'Ocupación de propiedades',
    'panel.ocupadasAhora': 'Ocupadas ahora ({total})',
    'panel.ningunaOcupada': 'Ninguna ocupada ahora mismo.',
    'panel.proximasLlegadas': 'Próximas llegadas ({total})',
    'panel.noches': '{total} noches',
    'panel.proximasVisitas': 'Próximas visitas programadas',
    'panel.cargaOperativa': 'Carga operativa por persona',
    'panel.horasPorTrabajador': 'Horas por trabajador',
    'panel.actividadReciente': 'Actividad reciente',
    'mant.nueva': 'Nueva tarea de mantenimiento',
    'mant.titulo': 'Título',
    'mant.area': 'área',
    'mant.frecuencia': 'Frecuencia',
    'mant.antelacion': 'Días de antelación',
    'mant.fechaInicio': 'Fecha de inicio',
    'mant.comoVisita': 'Como visita',
    'mant.comoIncidencia': 'Como incidencia',
    'mant.proveedorOpcional': 'Proveedor (opcional)',
    'mant.guardar': 'Guardar tarea',
    'prov.nuevo': 'Nuevo proveedor',
    'prov.empresa': 'Empresa',
    'prov.categoria': 'Categoría',
    'prov.contacto': 'Contacto',
    'prov.productos': 'Productos / garantías y notas',
    'prov.productosPista': 'Ej: Caldera Vaillant, garantía hasta 2028',
    'gasto.registrar': 'Registrar gasto',
    'gasto.importe': 'Importe (EUR)',
    'gasto.fecha': 'Fecha del gasto',
    'gasto.margen': 'Margen beneficio (%)',
    'gasto.sinProveedor': 'Sin proveedor',
    'gasto.nombreLibre': 'Nombre libre',
    'gasto.nombreLibrePista': 'Ej: Leroy Merlin',
    'gasto.conceptoPista': 'Ej: Materiales fontanería',
    'gasto.facturable': 'Facturable al cliente',
    'gasto.visiblePortal': 'Visible en portal del cliente',
    'gasto.ticket': 'Foto del ticket / factura',
    'gasto.registrarBoton': 'Registrar',
    'gasto.anadir': 'Añadir',
    'doc.fichero': 'Fichero',
    'doc.tipos': 'PDF, Word, Excel o imagen. Máximo 20 MB.',
    'visita.programar': 'Programar visita',
    'avisos.titulo': 'Notificaciones',
    'avisos.vacio': 'Nada pendiente. Todo al día.',
    'avisos.marcarTodas': 'Marcar todas',
    'avisoTipo.INCIDENCIA_CRITICA': 'Incidencia crítica',
    'avisoTipo.VISITA_VENCIDA': 'Visita vencida',
    'avisoTipo.MANTENIMIENTO_VENCIDO': 'Mantenimiento vencido',
    'avisoTipo.GASTO_PENDIENTE': 'Gasto pendiente de aprobar',
    'avisoTipo.PAGO_RECURRENTE': 'Pago recurrente',
    'avisoTipo.FACTURA_VENCIDA': 'Factura vencida',
    'avisoTipo.OTRO': 'Aviso',
    'verComo.etiqueta': 'Ver como',
    'verComo.aviso': 'Estás viendo la aplicación como {rol}.',
    'verComo.volver': 'Volver a {rol}',
    'inc.proveedor': 'Proveedor',
    'inc.sinAsignar': 'Sin asignar',
    'inc.elegirProveedor': 'Elegir proveedor...',
    'inc.quitar': 'Quitar',
    'inc.presupuestos': 'Presupuestos recibidos',
    'inc.solicitar': 'Solicitar',
    'inc.sinPresupuestos': 'Aún no hay presupuestos.',
    'inc.guardarPresupuesto': 'Guardar presupuesto',
    'inc.estado': 'Estado',
    'inc.pedirMotivo': '¿Por qué se anula? Queda escrito en la incidencia.',
    'inc.pedirResolucion': '¿Cómo se resolvió? Queda escrito en la incidencia.',
    'inc.urgencia': 'Urgencia',
    'inc.costeEstimado': 'Coste estimado',
    'inc.costeFinal': 'Coste final',
    'inc.fotos': 'Fotos de evidencia',
    'inc.anadirFoto': 'Añadir foto',
    'inc.sinFotos': 'Sin fotos ni documentos.',
    'inc.chatInterno': 'Chat interno',
    'inc.chatInternoNota': 'Sin comentarios todavía. Sé el primero en escribir.',
    'inc.mensajesCliente': 'Mensajes con el cliente',
    'inc.mensajesClienteNota': 'Sin mensajes todavía. El cliente también puede escribir aquí.',
    'inc.visibleAlCliente': 'Visible al cliente',
    'inc.enviar': 'Enviar',
    'inc.fechaEsperada': 'Fecha esperada de resolución',
    'inc.fechaEsperadaNota': 'La fecha que el equipo se pone. Aparece en «Tareas del día» el día que llega, y en rojo si pasa sin cerrarla. No es el SLA.',
    'inc.visibilidad': 'Visibilidad en portales',
    'inc.visiblePropietario': 'Visible al propietario',
    'inc.ocultaPropietario': 'Oculta al propietario',
    'inc.visibilidadNota': 'El propietario solo ve las incidencias marcadas como visibles.',
    'inc.creada': 'Creada',
    'inc.cerrada': 'Cerrada',
    'adjunto.tipoNoAdmitido': 'Ese tipo de fichero no se admite.',
    'adjunto.demasiadoGrande': 'El fichero supera el tamaño máximo (20 MB).',
    'adjunto.vacio': 'El fichero está vacío.',
    'adjunto.rutaInvalida': 'Ruta de fichero no válida.',
    'ficha.filtroABIERTAS': 'Abiertas',
    'ficha.filtroCERRADAS': 'Cerradas',
    'ficha.filtroTODAS': 'Todas',
    'ficha.nivel': 'Nivel',
    'ficha.todos': 'Todos',
    'ficha.sinIncidencias': 'Sin incidencias con este filtro.',
    'ficha.slaIncumplido': 'SLA incumplido',
    'ficha.estimado': 'est.',
    'ficha.final': 'final',
    'ficha.precioCliente': 'Precio cliente',
    'ficha.gastado': 'Gastado',
    'ficha.porCobrar': 'Por cobrar',
    'ficha.porCobrarAyuda': 'Lo que se le repercute al cliente, aprobado, marcado «Por cobrar» y todavía sin factura. Es el mismo número que el Panel.',
    'ficha.noRepercutido': '{importe} no se repercuten ({total})',
    'ficha.noRepercutidoAyuda': 'Gastos de la casa sin marcar «se le repercute al cliente». No suman en lo que se le cobra.',
    'ficha.repercutir': 'Repercutir al cliente',
    'ficha.repercutirAyuda': 'Este gasto no se le cobra al cliente. Púlsalo para que pase a «Por cobrar».',
    'ficha.noSeRepercute': 'No se repercute',
    'ficha.confirmarRepercutir': '¿Repercutir «{concepto}» al cliente? Pasará a «Por cobrar» y será visible en su portal.',
    'ficha.alCliente': 'al cliente',
    'ficha.sinFichero': 'sin fichero',
    'ficha.documentos': 'Contratos y documentos',
    'ficha.sinDocumentos': 'Sin documentos.',
    'ficha.subirDocumento': 'Subir documento',
    'ficha.tituloDocumento': 'Título del documento',
    'ficha.urlDocumento': 'Dirección del fichero',
    'ficha.abrir': 'Abrir',
    // --- IA y analitica -------------------------------------------------------
    'ia.anio': 'Año',
    'ia.mes': 'Mes',
    'ia.resumenesTitulo': 'Resúmenes del portal del cliente',
    'ia.resumenesIntro': 'Se genera sobre un mes cerrado, se revisa y se publica. El propietario lee lo que la empresa ha decidido contarle, no lo que un modelo improvisa mientras carga la página.',
    'ia.eligePropiedad': 'Elige una propiedad',
    'ia.idiomaResumen': 'Idioma del resumen',
    'ia.generar': 'Generar',
    'ia.generando': 'Generando…',
    'ia.sinResumenes': 'Todavía no hay ningún resumen de este mes.',
    'ia.estado.BORRADOR': 'Borrador',
    'ia.estado.PUBLICADO': 'Publicado',
    'ia.editar': 'Editar',
    'ia.guardar': 'Guardar',
    'ia.publicar': 'Publicar al cliente',
    'ia.retirar': 'Retirar del portal',
    'ia.escritoAMano': 'corregido a mano',
    'ia.conectada': 'Conectada',
    'ia.sinProveedor': 'Sin proveedor',
    'ia.sinProveedorNota': 'No hay proveedor de IA configurado, así que no se puede generar ningún resumen. Sin IA no se entrega un texto de plantilla disfrazado.',
    'ia.informesTitulo': 'Informes de actividad',
    'ia.informesIntro': 'Del mes seleccionado, en PDF. El de cada persona trae sus horas, sus visitas, las incidencias que resolvió y el cálculo de pago.',
    'ia.informeCartera': 'Cartera completa',
    'ia.informeCarteraNota': 'Todas las propiedades del mes',
    'ia.descargar': 'Descargar',
    'ia.conexionTitulo': 'Conexión con la IA',
    'ia.pruebaOk': 'La conexión funciona.',
    'ia.pruebaFallo': 'La conexión ha fallado.',
    'ia.noConfigurada': 'La IA no está configurada: no se puede generar el resumen.',
    'mes.enero': 'Enero',
    'mes.febrero': 'Febrero',
    'mes.marzo': 'Marzo',
    'mes.abril': 'Abril',
    'mes.mayo': 'Mayo',
    'mes.junio': 'Junio',
    'mes.julio': 'Julio',
    'mes.agosto': 'Agosto',
    'mes.septiembre': 'Septiembre',
    'mes.octubre': 'Octubre',
    'mes.noviembre': 'Noviembre',
    'mes.diciembre': 'Diciembre',
    'ia.titulo': 'IA e informes',
    'ia.sub': 'El resumen del mes que lee el propietario, y los informes de actividad.',
    'ia.conexion': 'Conexión con la IA',
    'ia.probar': 'Probar conexión',
    'ia.probando': 'Probando…',
    'ia.conexionPie': 'Hace una llamada real y mínima al proveedor. Cuesta unos céntimos, por eso no se hace sola al abrir esta pantalla. Es la conexión que usa el resumen del portal del cliente, que hoy es el único sitio donde la IA escribe algo.',
    'ia.noSeProbo': 'No se pudo probar la conexión.',
    'ia.anomalias': 'Gastos anómalos (últimos {meses} meses)',
    'ia.analizando': 'Analizando…',
    'ia.sinAnomalias': 'No se han detectado anomalías. Se revisa el gasto sobre el propio historial.',
    'ia.noSeCargaron': 'No se pudieron cargar las anomalías.',
    'ia.severidad': 'Severidad',
    'ia.tipo': 'Tipo',
    'ia.concepto': 'Concepto',
    'ia.propiedad': 'Propiedad',
    'ia.importe': 'Importe',
    'ia.motivo': 'Motivo',
    'ia.tipoOUTLIER': 'Importe atípico',
    'ia.tipoDUPLICADO': 'Posible duplicado',
    'ia.sevALTA': 'Alta',
    'ia.sevMEDIA': 'Media',
    'ia.sevBAJA': 'Baja',
    'ia.clasificar': 'Clasificar una incidencia',
    'ia.clasificarPie': 'Describe la incidencia y te sugiere nivel y categoría (no decide: sólo orienta). La sugerencia sale de una heurística de palabras, no de la IA.',
    'ia.clasificarEjemplo': 'Ej.: Hay una fuga de agua bajo el fregadero de la cocina',
    'ia.clasificarBoton': 'Clasificar',
    'ia.noSeClasifico': 'No se pudo clasificar.',
    'ia.nivelSugerido': 'Nivel {nivel}',
    'ia.porIa': 'por IA',
    'ia.porHeuristica': 'heurística',
    'iaCat.SEGURIDAD': 'Seguridad',
    'iaCat.FONTANERIA': 'Fontanería',
    'iaCat.ELECTRICIDAD': 'Electricidad',
    'iaCat.CLIMATIZACION': 'Climatización',
    'iaCat.CERRAJERIA': 'Cerrajería',
    'iaCat.EXTERIORES': 'Exteriores',
    'iaCat.MANTENIMIENTO': 'Mantenimiento',
    'iaCat.GENERAL': 'General',
    'dia.titulo': 'Tareas del día',
    'dia.nadaPendiente': 'Nada pendiente',
    'dia.pendientes': '{total} pendientes',
    'dia.vacio': 'No tienes tareas con fecha para hoy ni visitas agendadas. Las tareas sin fecha de entrega no aparecen aquí.',
    'dia.incidencias': 'Incidencias por atender',
    'dia.visitas': 'Visitas programadas',
    'dia.deProyectos': 'De proyectos',
    'dia.sinPropiedad': 'Sin propiedad',
    'dia.ver': 'Ver',
    'dia.hoy': 'Hoy',
    'dia.atrasada': 'Atrasada',
    'dia.completarTarea': 'Completar {titulo}',
    'dia.noSeCargo': 'No se pudo cargar el día.',
    'dia.noSeCompleto': 'No se pudo completar la tarea.',
    'fin.tarifasGenerales': 'Tarifas generales del equipo',
    'fin.tarifasGeneralesPie': 'Lo que cobra cada persona cuando la casa no tiene tarifa propia, y lo que se le paga por las horas internas. Pulsa un importe para cambiarlo.',
    'fin.titulo': 'Finanzas',
    'fin.sub': 'Resumen mensual: horas y gastos convertidos en lo que se factura.',
    'fin.registrar': '+ Registrar horas/gastos',
    'fin.ocultarRegistro': 'Ocultar registro',
    'fin.mes': 'Mes',
    'fin.anio': 'Año',
    'fin.noSeCargo': 'No se pudo cargar el resumen.',
    'fin.base': 'Base imponible',
    'fin.iva': 'IVA',
    'fin.total': 'Total',
    'fin.vacio': 'No hay horas ni gastos registrados en {mes} de {anio}.',
    'fin.colTipo': 'Tipo',
    'fin.colConcepto': 'Concepto',
    'fin.colPropiedad': 'Propiedad',
    'fin.colPersona': 'Persona',
    'fin.colBase': 'Base',
    'fin.colTotal': 'Total',
    'fin.colFacturacion': 'Facturación',
    'fin.tipoHORAS_FIJAS': 'Cuota fija',
    'fin.tipoHORAS': 'Horas',
    'fin.tipoGASTO': 'Gasto',
    'fin.modoFACTURA_CON_IVA': 'Factura con IVA',
    'fin.modoPRESUPUESTO_SIN_IVA': 'Presupuesto',
    'fin.modoHOLDED': 'Holded',
    'ref.titulo': 'Referidos',
    'ref.sub': 'Quién te trae negocio y su comisión.',
    'ref.nuevo': 'Nuevo referido',
    'ref.nombrePlaceholder': 'Nombre del referido',
    'ref.comision': 'Comisión',
    'ref.porcentaje': 'Porcentaje',
    'ref.fija': 'Fija',
    'ref.porcentajeCampo': 'Porcentaje (%)',
    'ref.importeCampo': 'Importe (€)',
    'ref.anadir': '+ Añadir',
    'ref.filtroTODOS': 'Todos',
    'ref.filtroPENDIENTE': 'Pendientes',
    'ref.filtroCONVERTIDO': 'Convertidos',
    'ref.filtroDESCARTADO': 'Descartados',
    'ref.vacio': 'No hay referidos en este estado.',
    'ref.colReferido': 'Referido',
    'ref.colQuienRefiere': 'Quién refiere',
    'ref.colEstado': 'Estado',
    'ref.colAcciones': 'Acciones',
    'ref.estadoPENDIENTE': 'Pendiente',
    'ref.estadoCONVERTIDO': 'Convertido',
    'ref.estadoDESCARTADO': 'Descartado',
    'ref.basePlaceholder': 'base €',
    'ref.baseDe': 'Base para {nombre}',
    'ref.convertir': 'Convertir',
    'ref.descartar': 'Descartar',
    'ref.motivoDescarte': 'Descartado desde el panel',
    'ref.noSeCargaron': 'No se pudieron cargar los referidos.',
    'ref.noSeCreo': 'No se pudo crear el referido.',
    'ref.noSeConvirtio': 'No se pudo convertir.',
    'ref.noSeDescarto': 'No se pudo descartar.',
    'import.crmTitulo': 'Oportunidades del CRM anterior',
    'import.crmIntro': 'Trae el embudo comercial del CRM anterior. Se puede repetir: cada oportunidad viaja con el identificador que tenía en su origen y la segunda pasada actualiza en vez de duplicar.',
    'import.crmOportunidades': 'oportunidades',
    'import.crmCreadas': 'Creadas',
    'import.crmActualizadas': 'Actualizadas',
    'import.crmTotal': 'Total',
    'import.crmSuma': 'Valor total',
    'import.crmNotas': 'Notas nuevas',
    'import.crmTareas': 'Tareas nuevas',
    'import.crmFusionadas': 'Reconocidas por su nombre ({n}):',
    'import.crmPorEmbudo': 'Por embudo',
    'import.crmEmbudosCreados': 'Embudos creados',
    'import.crmEtapasCreadas': 'Etapas creadas',
    'import.crmResponsables': 'Responsables reconocidos',
    'import.embudoDesconocido': 'Ese embudo no existe en la aplicación. Créalo antes de importar.',
    'import.etapaDesconocida': 'Una etapa del fichero no existe en su embudo. No se ha importado nada.',
    'import.exclusivoDesconocido': 'Una oportunidad del fichero es exclusiva de alguien que no es usuario de la empresa. No se ha importado nada.',
    'import.externalIdRepetido': 'El fichero trae dos veces la misma oportunidad.',
    'import.totalNoCuadra': 'El recuento no cuadra con lo esperado. No se ha importado nada.',
    'import.sumaNoCuadra': 'La suma de valores no cuadra con lo esperado. No se ha importado nada.',
    'crm.embudo': 'Embudo',
    'crm.origen': 'Origen',
    'crm.etiquetas': 'Etiquetas',
    'crm.contacto': 'Contacto',
    'crm.responsableOriginal': 'Responsable en el CRM anterior',
    'crm.datosExternos': 'Cualificación heredada',
    'crm.importada': 'Importada',
    'crm.sub': 'Gestiona tus ventas por embudos.',
    'crm.nuevaOportunidad': 'Nueva oportunidad',
    'crm.nombrePlaceholder': 'Nombre (p. ej. Villa del acantilado)',
    'crm.valor': 'Valor (€, opcional)',
    'crm.anadir': '+ Añadir',
    'crm.ganada': 'Ganada',
    'crm.perdida': 'Perdida',
    'crm.mover': 'Mover {nombre}',
    'crm.noSeCargaronEmbudos': 'No se pudieron cargar los embudos.',
    'crm.noSeCargaronOportunidades': 'No se pudieron cargar las oportunidades.',
    'crm.faltaNombre': 'Escribe un nombre para la oportunidad.',
    'crm.noSeCreo': 'No se pudo crear la oportunidad.',
    'crm.noSeMovio': 'No se pudo mover la oportunidad.',
    'crm.ficha.info': 'Contacto y oportunidad',
    'crm.ficha.propiedad': 'Detalles de la propiedad',
    'crm.ficha.tareas': 'Tareas',
    'crm.ficha.notas': 'Notas',
    'crm.ficha.contacto': 'Detalles del contacto',
    'crm.ficha.oportunidad': 'Detalles de la oportunidad',
    'crm.ficha.ocultarVacios': 'Ocultar campos vacíos',
    'crm.ficha.contactoNombre': 'Nombre del contacto principal',
    'crm.ficha.email': 'Correo electrónico',
    'crm.ficha.telefono': 'Teléfono',
    'crm.ficha.llamar': 'Llamar',
    'crm.ficha.adicionales': 'Contactos adicionales (máx. 10)',
    'crm.ficha.anadirContacto': 'Añadir contacto',
    'crm.ficha.rol': 'Cargo',
    'crm.ficha.nombre': 'Nombre de la oportunidad',
    'crm.ficha.embudo': 'Embudo',
    'crm.ficha.etapa': 'Etapa',
    'crm.ficha.estado': 'Estado',
    'crm.estado.ABIERTA': 'Abierta',
    'crm.estado.GANADA': 'Ganada',
    'crm.estado.PERDIDA': 'Perdida',
    'crm.ficha.valor': 'Valor (€)',
    'crm.ficha.motivoPerdida': 'Motivo de la pérdida',
    'crm.ficha.propietario': 'Propietario',
    'crm.ficha.sinAsignar': 'Sin asignar',
    'crm.ficha.seguidores': 'Seguidores',
    'crm.ficha.anadirSeguidor': 'Añadir seguidor',
    'crm.ficha.quitar': 'Quitar',
    'crm.ficha.empresa': 'Nombre de la empresa',
    'crm.ficha.fuente': 'Fuente',
    'crm.ficha.cierrePrevisto': 'Fecha prevista de cierre',
    'crm.ficha.etiquetas': 'Etiquetas',
    'crm.ficha.anadirEtiqueta': 'Añadir etiqueta',
    'crm.ficha.encaje': 'Encaje cultural',
    'crm.ficha.idioma': 'Idioma',
    'crm.ficha.usoReal': 'Uso real del inmueble',
    'crm.ficha.riesgos': 'Riesgos detectados',
    'crm.ficha.zona': 'Zona',
    'crm.ficha.superficie': 'Superficie aproximada',
    'crm.ficha.tipoPropiedad': 'Tipo de propiedad',
    'crm.ficha.vistas': 'Vistas',
    'crm.ficha.m2Solar': 'M² mín. del solar',
    'crm.ficha.m2Habitables': 'M² mín. habitables',
    'crm.ficha.dormitorios': 'Número de dormitorios',
    'crm.ficha.banos': 'Número de baños',
    'crm.ficha.propuestoMax': 'Propuesto máx. €',
    'crm.ficha.estaEnLaIsla': 'Está en la isla',
    'crm.ficha.viveEnLaIsla': 'Vive en la isla',
    'crm.ficha.creadoPor': 'Creado por: {nombre}',
    'crm.ficha.creadoEl': 'Creado el {fecha}',
    'crm.ficha.guardado': 'Guardado.',
    'crm.ficha.descartarCambios': 'Hay cambios sin guardar. ¿Cerrar igualmente?',
    'crm.ficha.anadirTarea': 'Añadir tarea',
    'crm.ficha.tituloTarea': 'Qué hay que hacer',
    'crm.ficha.vence': 'Fecha',
    'crm.ficha.responsableTarea': 'Quién la hace',
    'crm.ficha.detalleTarea': 'Detalle (opcional)',
    'crm.ficha.tareaEnPanel': 'Le aparecerá en su panel del día a quien la haga.',
    'crm.ficha.buscarTarea': 'Buscar por título',
    'crm.ficha.sinTareas': 'Todavía no hay tareas.',
    'crm.ficha.sinFechaNiResponsable': 'Sin fecha ni responsable',
    'crm.ficha.buscarNotas': 'Buscar notas',
    'dia.crm': 'De oportunidades',
    'crm.exclusiva': 'Exclusiva de {nombre}',
    'crm.error.exclusivoSinCrm': 'Esa persona no tiene acceso al CRM: no puede llevar una oportunidad en exclusiva.',
    'crm.asistente.titulo': 'Asistente',
    'crm.asistente.abrir': 'Asistente',
    'crm.asistente.intro': 'Cuéntame qué ha pasado con un cliente, como se lo contarías a un compañero, o pega la captura de la conversación. Te propongo la nota, la columna y el siguiente paso; tú decides qué se aplica.',
    'crm.asistente.placeholder': 'Ej.: Hablé con Pouline, está analizando nuestra oferta',
    'crm.asistente.enviar': 'Enviar',
    'crm.asistente.adjuntar': 'Adjuntar captura',
    'crm.asistente.dictar': 'Dictar',
    'crm.asistente.pararDictado': 'Terminar de dictar',
    'crm.asistente.escuchando': 'Escuchando… habla con normalidad y toca el micrófono para terminar. Revísalo antes de enviar.',
    'crm.asistente.dictado.noSoportado': 'Este navegador no permite dictar. En el móvil, usa el micrófono del teclado.',
    'crm.asistente.dictado.permiso': 'Para dictar, permite el uso del micrófono en el navegador.',
    'crm.asistente.dictado.sinVoz': 'No te he oído. Toca el micrófono y vuelve a probar.',
    'crm.asistente.dictado.red': 'Sin conexión con el servicio de dictado. Prueba otra vez.',
    'crm.asistente.dictado.otro': 'No se pudo dictar. Prueba otra vez.',
    'crm.asistente.quitarCaptura': 'Quitar la captura',
    'crm.asistente.demasiadas': 'Como mucho 6 capturas por mensaje.',
    'crm.asistente.pensando': 'Leyendo… {segundos} s',
    'crm.asistente.pensandoPie': 'Con capturas puede tardar hasta un minuto.',
    'crm.asistente.aplicar': 'Aplicar',
    'crm.asistente.aplicarN': 'Aplicar ({n})',
    'crm.asistente.descartar': 'Descartar',
    'crm.asistente.aplicada': 'Aplicada',
    'crm.asistente.aplicadoUna': 'Hecho: oportunidad actualizada.',
    'crm.asistente.aplicadoVarias': 'Hecho: {n} oportunidades actualizadas.',
    'crm.asistente.descartado': 'Descartado. No se ha cambiado nada.',
    'crm.asistente.nota': 'Nota',
    'crm.asistente.mover': 'Mover de «{desde}» a «{hasta}»',
    'crm.asistente.tarea': 'Tarea: {titulo}',
    'crm.asistente.tareaVence': 'Tarea: {titulo} · {fecha}',
    'crm.asistente.confianzaALTA': 'Seguro',
    'crm.asistente.confianzaMEDIA': 'Probable',
    'crm.asistente.confianzaBAJA': 'Dudoso',
    'crm.asistente.ganada': 'La cierra como ganada',
    'crm.asistente.perdida': 'La cierra como perdida',
    'crm.asistente.descartadas': 'No se propone:',
    'crm.asistente.transcripcion': 'Lo que leí en las capturas',
    'crm.asistente.nuevo': 'Nueva conversación',
    'crm.asistente.error': 'No he podido interpretarlo. Vuelve a intentarlo.',
    'crm.asistente.sinIa': 'El asistente no está configurado: falta la clave de IA.',
    'crm.detalle.abrir': 'Abrir {nombre}',
    'crm.detalle.exclusiva': 'Gestión exclusiva',
    'crm.detalle.nadie': 'Nadie: la puede contactar cualquiera',
    'crm.detalle.nuevaNota': 'Añadir una nota',
    'crm.detalle.guardarNota': 'Guardar nota',
    'crm.detalle.sinHistorial': 'Sin notas todavía.',
    'crm.actividad.NOTA': 'Nota',
    'crm.actividad.LLAMADA': 'Llamada',
    'crm.actividad.REUNION': 'Reunión',
    'crm.actividad.EMAIL': 'Correo',
    'crm.actividad.TAREA': 'Tarea',
    'finreg.titulo': 'Registrar horas y gastos',
    'finreg.horas': 'Horas',
    'finreg.gasto': 'Gasto',
    'finreg.persona': 'Persona',
    'finreg.yo': 'Yo ({nombre})',
    'finreg.propiedad': 'Propiedad',
    'finreg.general': '— General —',
    'finreg.fecha': 'Fecha',
    'finreg.tipo': 'Tipo',
    'finreg.tipoGESTION': 'Gestión',
    'finreg.tipoOTRO': 'Otro',
    'finreg.registrarHoras': 'Registrar horas',
    'finreg.concepto': 'Concepto',
    'finreg.conceptoPlaceholder': 'Material, transporte…',
    'finreg.categoria': 'Categoría',
    'finreg.catLOGISTICA': 'Logística',
    'finreg.catCOMPRA': 'Compra',
    'finreg.catOTRO': 'Otro',
    'finreg.coste': 'Coste (€)',
    'finreg.margen': 'Margen (%)',
    'finreg.registrarGasto': 'Registrar gasto',
    'finreg.tarifas': 'Tarifas del equipo',
    'finreg.tarifasPie': 'Sin tarifa, las horas registradas salen a 0 €. Fija cuánto cobra cada persona: fija al mes por propiedad, o por hora.',
    'finreg.tarifasSinPropiedad': 'La tarifa sin propiedad es la que se aplica a las horas internas, y también a cualquier casa que no tenga una tarifa propia.',
    'finreg.horasInternas': 'Horas internas · sin propiedad',
    'finreg.horasInternasOpcion': '— Horas internas · sin propiedad —',
    'finreg.modalidad': 'Modalidad',
    'finreg.porHora': 'Por hora',
    'finreg.fijaMes': 'Fija al mes',
    'finreg.fijaMesCorto': 'Fija/mes',
    'finreg.importe': 'Importe (€)',
    'finreg.fijarTarifa': 'Fijar tarifa',
    'finreg.tarifaFijada': 'Tarifa fijada.',
    'finreg.horasRegistradas': 'Horas registradas.',
    'finreg.facturaNoSubio': 'El gasto se registró, pero la factura no se pudo subir.',
    'finreg.gastoRegistrado': 'Gasto registrado.',
    'finreg.indicaImporte': 'Indica el importe de la tarifa.',
    'finreg.indicaHoras': 'Indica cuántas horas.',
    'finreg.indicaGasto': 'Indica concepto e importe del gasto.',
    'finreg.noSeFijo': 'No se pudo fijar la tarifa.',
    'finreg.noSeRegistraronHoras': 'No se pudieron registrar las horas.',
    'finreg.noSeRegistroGasto': 'No se pudo registrar el gasto.',
    'app.modulos': 'Módulos',
    'app.navegacion': 'Navegación',
    'proy.titulo': 'Proyectos',
    'proy.sub': 'Equipos, proyectos y tareas.',
    'proy.estadoTODO': 'Por hacer',
    'proy.estadoEN_CURSO': 'En curso',
    'proy.estadoBLOQUEADA': 'Bloqueada',
    'proy.estadoHECHA': 'Hecha',
    'proy.hoy': 'Hoy',
    'proy.ayer': 'Ayer',
    'proy.manana': 'Mañana',
    'proy.sinSeccion': 'Sin sección',
    'proy.subtareas': 'Subtareas',
    'proy.comentarios': 'Comentarios',
    'proy.adjuntos': 'Adjuntos',
    'proy.reabrir': 'Reabrir {titulo}',
    'proy.completar': 'Completar {titulo}',
    'proy.unaTarea': '{total} tarea',
    'proy.variasTareas': '{total} tareas',
    'proy.vista': 'Vista',
    'proy.lista': 'Lista',
    'proy.tablero': 'Tablero',
    'proy.buscarTarea': 'Buscar tarea',
    'proy.verCompletadas': 'Ver completadas',
    'proy.colNombre': 'Nombre de la tarea',
    'proy.colResponsable': 'Responsable',
    'proy.colFecha': 'Fecha de entrega',
    'proy.colColaboradores': 'Colaboradores',
    'proy.anadirTarea': '+ Añadir tarea',
    'proy.anadirTareaEn': 'Añadir tarea en {seccion}',
    'proy.estadoDe': 'Estado de {titulo}',
    'proy.nuevaSeccion': 'Nueva sección',
    'proy.anadirSeccion': '+ Añadir sección',
    'proy.sinEquipos': 'Aún no hay equipos. Crea el primero abajo.',
    'proy.sinProyectos': 'Sin proyectos todavía.',
    'proy.nuevoProyecto': 'Nuevo proyecto',
    'proy.nuevoProyectoEn': 'Nuevo proyecto en {equipo}',
    'proy.nuevoEquipo': 'Nuevo equipo',
    'proy.nombreEquipo': 'Nombre del equipo',
    'proy.anadir': '+ Añadir',
    'proy.noSeCargaron': 'No se pudieron cargar los proyectos.',
    'proy.noSeAbrio': 'No se pudo abrir el proyecto.',
    'proy.noSeCreoTarea': 'No se pudo crear la tarea.',
    'proy.noSeCambio': 'No se pudo cambiar la tarea.',
    'proy.noSeMovio': 'No se pudo mover la tarea.',
    'proy.noSeCreoSeccion': 'No se pudo crear la sección.',
    'proy.noSeCreoProyecto': 'No se pudo crear el proyecto.',
    'proy.noSeCreoEquipo': 'No se pudo crear el equipo.',
    'tarea.completada': '✓ Completada',
    'tarea.marcarCompletada': 'Marcar completada',
    'tarea.cerrar': 'Cerrar',
    'tarea.titulo': 'Título de la tarea',
    'tarea.responsables': 'Responsables',
    'tarea.quitarA': 'Quitar a {nombre}',
    'tarea.asignar': '+ Asignar',
    'tarea.fecha': 'Fecha de entrega',
    'tarea.prioridad': 'Prioridad',
    'tarea.prioALTA': 'Alta',
    'tarea.prioMEDIA': 'Media',
    'tarea.prioBAJA': 'Baja',
    'tarea.etiquetas': 'Etiquetas',
    'tarea.nuevaEtiqueta': '+ etiqueta',
    'tarea.anadirEtiqueta': 'Añadir etiqueta',
    'tarea.descripcion': 'Descripción',
    'tarea.subtareas': 'Subtareas',
    'tarea.anadirSubtarea': '+ Añadir subtarea',
    'tarea.reabrir': 'Reabrir {titulo}',
    'tarea.completar': 'Completar {titulo}',
    'tarea.comentarios': 'Comentarios',
    'tarea.sinComentarios': 'Todavía no hay ninguno.',
    'tarea.alguien': 'Alguien',
    'tarea.escribeComentario': 'Escribe un comentario',
    'tarea.noSeAbrio': 'No se pudo abrir la tarea.',
    'tarea.noSeGuardo': 'No se pudo guardar el cambio.',
    'tarea.noSeCambioSubtarea': 'No se pudo cambiar la subtarea.',
    'tarea.noSeQuitoEtiqueta': 'No se pudo quitar la etiqueta.',
    'tarea.noSePusoEtiqueta': 'No se pudo poner la etiqueta.',
    'tarea.noSeCreoSubtarea': 'No se pudo crear la subtarea.',
    'tarea.noSePublico': 'No se pudo publicar el comentario.',
    'ia.menu': 'IA',
    'obras.entrada': 'Oportunidades de obra',
    'obras.embudos': 'Embudos comerciales',
    'obras.titulo': 'Oportunidades de obra',
    'obras.sub': 'Obras en marcha en Mallorca que se acercan a su entrega, y con quien hay que hablar.',
    'obras.simulacion': 'Los permisos por rol todavía se simulan con el selector de abajo; las oportunidades sí se guardan.',
    'obras.cActivas': 'Activas',
    'obras.cPendientes': 'Sin contactar',
    'obras.cContacto': 'En contacto',
    'obras.cFin': 'Entrega proxima',
    'obras.cVencidas': 'Acciones vencidas',
    'obras.cAlta': 'Prioridad alta',
    'obras.buscar': 'Buscar por nombre, direccion, zona, codigo o contacto',
    'obras.nueva': '+ Nueva oportunidad',
    'obras.mapa': 'Mapa',
    'obras.lista': 'Lista',
    'obras.mapaCalle': 'Callejero',
    'obras.mapaSatelite': 'Satélite',
    'obras.mapaPie': 'Amplía con los botones + / − o con Ctrl y la rueda. Pulsa una chincheta para ver la ficha rápida; púlsala otra vez para abrir la obra.',
    'obras.verMapa': 'Ver en el mapa',
    'obras.verLista': 'Ver en lista',
    'obras.filtros': 'Filtros',
    'obras.limpiar': 'Limpiar filtros',
    'obras.atajos': 'Atajos',
    'obras.soloVencidas': 'Solo acciones vencidas',
    'obras.soloAlta': 'Solo prioridad alta',
    'obras.soloFin': 'Entrega en 90 dias',
    'obras.soloPendientes': 'Pendientes de contactar',
    'obras.soloActivas': 'Ocultar cerradas',
    'obras.resultados': '{total} de {sobre}',
    'obras.zoom': 'Zoom del mapa',
    'obras.acercar': 'Acercar',
    'obras.alejar': 'Alejar',
    'obras.encuadrar': 'Ajustar a las obras',
    'obras.mapaVacio': 'Ninguna obra cumple los filtros.',
    'obras.mapaNota': 'Mapa propio, sin proveedor externo. El contorno es real; los barrios, aproximados, y las direcciones, ficticias.',
    'obras.leyenda': 'Como leer un marcador',
    'obras.leyendaAnillo': 'El anillo y el numero: avance de la obra',
    'obras.leyendaDistintivo': 'El distintivo: como va la conversacion',
    'obras.abrir': 'Abrir oportunidad',
    'obras.cerrarFicha': 'Cerrar la ficha',
    'obras.progreso': 'Progreso',
    'obras.fase': 'Fase',
    'obras.finEstimada': 'Finalizacion estimada',
    'obras.puntuacion': 'Puntuacion',
    'obras.responsable': 'Responsable',
    'obras.sinResponsable': 'Sin asignar',
    'obras.ultimaComprobacion': 'Ultima comprobacion',
    'obras.promotorPropietario': 'Promotor o propietario',
    'obras.valorMercado': 'Valor de mercado',
    'obras.potencial': 'Potencial para SOLUXE',
    'obras.etapaComercial': 'Estado comercial',
    'obras.zona': 'Zona',
    'obras.municipio': 'Municipio',
    'obras.direccion': 'Direccion',
    'obras.codigoPostal': 'Codigo postal',
    'obras.codigo': 'Codigo',
    'obras.tipoProyecto': 'Tipo de proyecto',
    'obras.confianza': 'Confianza de la estimacion',
    'obras.sinDato': 'Sin dato',
    'obras.desconocido': 'Todavia no se sabe',
    'obras.proximaAccion': 'Proxima accion',
    'obras.sinProxima': 'Sin proxima accion',
    'obras.sinProximaAviso': 'Esta oportunidad esta activa y no tiene nada previsto.',
    'obras.marcarHecha': 'Marcar hecha',
    'obras.nuevaAccion': 'Nueva accion',
    'obras.quienLaHace': 'Quien la hace',
    'obras.cuando': 'Cuando',
    'obras.prioridadCampo': 'Prioridad',
    'obras.recordatorio': 'Recordarmelo',
    'obras.recordatorioNota': 'El recordatorio es interno y simulado: no se envia nada a nadie.',
    'obras.anadirAccion': 'Anadir accion',
    'obras.descripcion': 'Descripcion',
    'obras.porQue': 'Por que esta puntuacion',
    'obras.comoSeCalcula': 'Suma de siete reglas fijas. No interviene ninguna IA y el resultado no cambia entre dos consultas.',
    'obras.pt.cerrada': 'Oportunidad cerrada: no compite por atencion',
    'obras.pt.finEn': 'Finalizacion prevista en {dias} dias',
    'obras.pt.finPasada': 'La fecha prevista paso hace {dias} dias',
    'obras.pt.sinFecha': 'Sin fecha de finalizacion',
    'obras.pt.valor': 'Valor de mercado',
    'obras.pt.sinValor': 'Valor de mercado desconocido',
    'obras.pt.decisor': 'Hay alguien que decide identificado',
    'obras.pt.propietarioConocido': 'Propietario conocido, sin decisor confirmado',
    'obras.pt.sinDecisor': 'Sin propietario ni decisor identificado',
    'obras.pt.contacto': 'Hay telefono o correo directo',
    'obras.pt.sinContacto': 'Sin datos de contacto utilizables',
    'obras.pt.avance': 'La conversacion ya ha avanzado',
    'obras.pt.potencial': 'Potencial estimado para SOLUXE',
    'obras.pt.sinVerificar': 'Nunca se ha verificado sobre el terreno',
    'obras.pt.vieja': 'Informacion sin verificar desde hace {dias} dias',
    'obras.prioridad.ALTA': 'Prioridad alta',
    'obras.prioridad.MEDIA': 'Prioridad media',
    'obras.prioridad.BAJA': 'Prioridad baja',
    'obras.frescura.RECIENTE': 'Actualizada',
    'obras.frescura.VERIFICAR': 'Conviene verificar',
    'obras.frescura.DESACTUALIZADA': 'Desactualizada',
    'obras.frescura.SIN_VERIFICAR': 'Sin verificar',
    'obras.comprobar': 'Registrar comprobacion',
    'obras.comprobarNota': 'Que se ha visto',
    'obras.estadoAccion.VENCIDA': 'Vencida',
    'obras.estadoAccion.HOY': 'Para hoy',
    'obras.estadoAccion.PROXIMA': 'Proxima',
    'obras.estadoAccion.SIN_ACCION': 'Sin accion',
    'obras.fase.PREPARACION_TERRENO': 'Preparacion del terreno',
    'obras.fase.CIMENTACION': 'Cimentacion',
    'obras.fase.ESTRUCTURA': 'Estructura',
    'obras.fase.CERRAMIENTOS': 'Cerramientos',
    'obras.fase.INSTALACIONES': 'Instalaciones',
    'obras.fase.ACABADOS_INTERIORES': 'Acabados interiores',
    'obras.fase.EXTERIORES': 'Exteriores y paisajismo',
    'obras.fase.PREPARACION_ENTREGA': 'Preparacion para entrega',
    'obras.fase.FINALIZADA': 'Finalizada',
    'obras.fase.DESCONOCIDO': 'Estado desconocido',
    'obras.confianza.BAJA': 'Baja',
    'obras.confianza.MEDIA': 'Media',
    'obras.confianza.ALTA': 'Alta',
    'obras.etapa.DETECTADA': 'Detectada',
    'obras.etapa.INVESTIGANDO': 'Investigando',
    'obras.etapa.PENDIENTE_CONTACTAR': 'Pendiente de contactar',
    'obras.etapa.CONTACTADA': 'Contactada',
    'obras.etapa.CONVERSACION': 'Conversacion iniciada',
    'obras.etapa.REUNION': 'Reunion programada',
    'obras.etapa.PROPUESTA': 'Propuesta enviada',
    'obras.etapa.GANADA': 'Ganada',
    'obras.etapa.PERDIDA': 'Perdida',
    'obras.etapa.PAUSA': 'En pausa',
    'obras.tipo.VILLA': 'Villa individual',
    'obras.tipo.PROMOCION': 'Promocion residencial',
    'obras.tipo.APARTAMENTO': 'Apartamento o atico',
    'obras.tipo.REFORMA': 'Reforma integral',
    'obras.tipo.OTRO': 'Otro',
    'obras.rol.PROPIETARIO': 'Propietario',
    'obras.rol.PROMOTOR': 'Promotor',
    'obras.rol.CONSTRUCTORA': 'Constructora',
    'obras.rol.ARQUITECTO': 'Arquitecto',
    'obras.rol.PROJECT_MANAGER': 'Project manager',
    'obras.rol.COMERCIALIZADORA': 'Comercializadora',
    'obras.rol.AGENTE': 'Agente inmobiliario',
    'obras.rol.OTRO': 'Otro contacto',
    'obras.influencia.DECIDE': 'Decide',
    'obras.influencia.INFLUYE': 'Influye',
    'obras.influencia.INFORMA': 'Informa',
    'obras.canal.TELEFONO': 'Telefono',
    'obras.canal.EMAIL': 'Correo',
    'obras.canal.WHATSAPP': 'WhatsApp',
    'obras.canal.PRESENCIAL': 'En persona',
    'obras.accionTipo.INVESTIGAR': 'Investigar',
    'obras.accionTipo.LLAMAR': 'Llamar',
    'obras.accionTipo.EMAIL': 'Enviar email',
    'obras.accionTipo.WHATSAPP': 'Enviar WhatsApp',
    'obras.accionTipo.VISITAR': 'Visitar',
    'obras.accionTipo.PRESENTACION': 'Solicitar presentacion',
    'obras.accionTipo.REUNION': 'Programar reunion',
    'obras.accionTipo.PROPUESTA': 'Preparar propuesta',
    'obras.accionTipo.SEGUIMIENTO': 'Realizar seguimiento',
    'obras.accionTipo.VERIFICAR': 'Verificar avance',
    'obras.accionTipo.OTRO': 'Otro',
    'obras.apunte.CREACION': 'Oportunidad creada',
    'obras.apunte.ETAPA': 'Cambio de etapa',
    'obras.apunte.PROGRESO': 'Actualizacion de la obra',
    'obras.apunte.CONTACTO': 'Contacto',
    'obras.apunte.TAREA': 'Tarea',
    'obras.apunte.NOTA': 'Nota',
    'obras.apunte.LLAMADA': 'Llamada',
    'obras.apunte.EMAIL': 'Email',
    'obras.apunte.WHATSAPP': 'WhatsApp',
    'obras.apunte.VISITA': 'Visita',
    'obras.apunte.REUNION': 'Reunion',
    'obras.apunte.CONVERSION': 'Conversion',
    'obras.colNombre': 'Obra',
    'obras.colFin': 'Finalizacion',
    'obras.ordenar': 'Ordenar por',
    'obras.orden.PUNTUACION': 'Puntuacion',
    'obras.orden.PROGRESO': 'Progreso',
    'obras.orden.FINALIZACION': 'Finalizacion',
    'obras.orden.VALOR': 'Valor',
    'obras.orden.COMPROBACION': 'Ultima comprobacion',
    'obras.orden.ACCION': 'Proxima accion',
    'obras.nuevaTitulo': 'Nueva oportunidad de obra',
    'obras.editar': 'Editar oportunidad',
    'obras.gIdentificacion': 'Identificacion y ubicacion',
    'obras.gConstruccion': 'Construccion',
    'obras.gComercial': 'Informacion comercial',
    'obras.gSituacion': 'Situacion de la propiedad',
    'obras.nombreProvisional': 'Nombre provisional',
    'obras.nombreEjemplo': 'Ej.: Villa del acantilado',
    'obras.direccionEjemplo': 'Ej.: Cami de Son Vic 14',
    'obras.eligeZona': 'Elige una zona',
    'obras.situarTitulo': 'Situar en el mapa',
    'obras.situar': 'Buscar la dirección',
    'obras.situando': 'Buscando…',
    'obras.situada': 'Situada en',
    'obras.noSituada': 'No se ha encontrado esa dirección. Escribe la zona a mano y guarda igual.',
    'obras.zonaEjemplo': 'Ej.: Costa d’en Blanes',
    'obras.zonaNota': 'La zona sale de la dirección al buscarla, y se puede escribir a mano. Coloca la obra en el mapa.',
    'obras.origen': 'Origen de la informacion',
    'obras.etiquetas': 'Etiquetas',
    'obras.contactoMovil': 'Móvil del contacto',
    'obras.contactoEmail': 'Email del contacto',
    'obras.contactoNota': 'Se guardan como contacto principal de la obra. El resto de contactos se añaden en su ficha.',
    'obras.etiquetasNota': 'Separadas por comas',
    'obras.propietarioConocido': 'Tiene propietario conocido',
    'obras.usoDelPropietario': 'La usara el propietario',
    'obras.saldraAVenta': 'Saldra a la venta',
    'obras.yaEnVenta': 'Ya esta en venta',
    'obras.si': 'Si',
    'obras.no': 'No',
    'obras.guardar': 'Guardar oportunidad',
    'obras.guardarCambios': 'Guardar cambios',
    'obras.cancelar': 'Cancelar',
    'obras.faltaNombre': 'Escribe al menos un nombre provisional y una zona.',
    'obras.sinGuardar': 'Hay cambios sin guardar.',
    'obras.errorGuardar': 'No se pudo guardar.',
    'obras.dupTitulo': 'Esta obra podria estar registrada',
    'obras.dupExplicacion': 'Se parece a lo que ya hay. Nada se junta ni se borra solo: decide tu.',
    'obras.dup.direccion': 'Misma direccion',
    'obras.dup.nombre': 'Mismo nombre',
    'obras.dup.codigo': 'Mismo codigo',
    'obras.dup.promotor': 'Mismo promotor o constructora',
    'obras.dup.zona': 'Misma zona',
    'obras.dupAbrir': 'Abrir la que ya existe',
    'obras.dupSeguir': 'Es diferente, continuar',
    'obras.dupCancelar': 'Cancelar el alta',
    'obras.tab.resumen': 'Resumen',
    'obras.tab.fotos': 'Fotos',
    'obras.tab.seguimiento': 'Seguimiento',
    'obras.tab.contactos': 'Contactos y empresas',
    'obras.tab.tareas': 'Tareas',
    'obras.tab.obra': 'Informacion de la obra',
    'obras.tab.historial': 'Historial',
    'obras.volverLista': 'Volver a oportunidades',
    'obras.situacionFisica': 'Situacion fisica',
    'obras.situacionComercial': 'Situacion comercial',
    'obras.riesgos': 'Lo que falta por saber',
    'obras.riesgoSinPropietario': 'No se sabe quien es el propietario',
    'obras.riesgoSinContacto': 'No hay ningun telefono ni correo',
    'obras.riesgoSinFecha': 'No hay fecha estimada de finalizacion',
    'obras.riesgoVieja': 'La informacion lleva tiempo sin verificarse',
    'obras.riesgoSinValor': 'No hay valor de mercado estimado',
    'obras.sinRiesgos': 'No falta nada importante por saber.',
    'obras.comentarios': 'Comentarios sobre la obra',
    'obras.cambiarEtapa': 'Cambiar etapa',
    'obras.comentarioEtapa': 'Comentario del cambio',
    'obras.motivoPerdida': 'Motivo de la perdida',
    'obras.pidePerdida': 'Para marcarla como perdida hace falta un motivo.',
    'obras.confirmarGanada': 'Marcar como ganada',
    'obras.consecuenciaGanada': 'La oportunidad se cierra como ganada y se ofrece convertirla en cliente y propiedad.',
    'obras.registrar': 'Registrar',
    'obras.queHaPasado': 'Que ha pasado',
    'obras.seguimientoNota': 'Se anota en el historial. No se envia ningun mensaje de verdad.',
    'obras.anadirContacto': 'Anadir contacto',
    'obras.nombrePersonaEmpresa': 'Nombre de la persona o empresa',
    'obras.rolEnObra': 'Rol en la obra',
    'obras.telefono': 'Telefono',
    'obras.email': 'Correo electronico',
    'obras.web': 'Web',
    'obras.idiomaContacto': 'Idioma',
    'obras.canalPreferido': 'Canal preferido',
    'obras.nivelDecision': 'Nivel de decision',
    'obras.notas': 'Notas',
    'obras.sinContactar': 'Ha pedido que no se le contacte',
    'obras.sinContactarAviso': 'No contactar',
    'obras.quitarContacto': 'Quitar',
    'obras.sinContactos': 'Todavia no hay nadie asociado a esta obra.',
    'obras.convertir': 'Convertir en cliente y propiedad',
    'obras.convertirTitulo': 'Convertir la oportunidad',
    'obras.convertirNota': 'Simulacion: se crean un cliente y una propiedad de mentira, enlazados a esta oportunidad. Al recargar desaparecen.',
    'obras.queSeLleva': 'Que se lleva',
    'obras.llevaContactos': 'Los contactos',
    'obras.llevaHistorial': 'El historial comercial',
    'obras.llevaObra': 'Los datos de la obra',
    'obras.nombreCliente': 'Nombre del cliente',
    'obras.nombrePropiedad': 'Nombre de la propiedad',
    'obras.confirmarConversion': 'Convertir',
    'obras.convertida': 'Convertida en {cliente} y {propiedad}.',
    'obras.yaConvertida': 'Ya convertida',
    'obras.vacio': 'Todavia no hay ninguna obra registrada.',
    'obras.vacioPie': 'Registra la primera con el boton de arriba.',
    'obras.sinResultados': 'Ninguna obra cumple lo que has pedido.',
    'obras.sinResultadosPie': 'Prueba a limpiar los filtros.',
    'obras.reiniciar': 'Reiniciar la demostracion',
    'obras.accesoDenegado': 'Este modulo es del equipo comercial',
    'obras.accesoDenegadoPie': 'Tu perfil no tiene acceso a las oportunidades de obra.',
    'obras.permisoSimulado': 'Los permisos de este modulo estan SIMULADOS en la interfaz. No son una barrera de seguridad: no hay servidor detras que los compruebe.',
    'obras.cargando': 'Cargando las oportunidades…',
    'obras.noSeGuardo': 'No se pudo guardar «{obra}». Revisa la conexión y vuelve a intentarlo.',
    'obras.fichas': 'Fichas de campo',
    'obras.fichasTitulo': 'Fichas de campo',
    'obras.fichasSub': 'Sube las fotos de las fichas del día y se leen una a una.',
    'obras.fichasSubir': 'Fotos de las fichas',
    'obras.fichasNota': 'Cada foto sale como un borrador para repasar. No se da de alta nada solo: guardas tú, con el formulario de siempre.',
    'obras.fichasLeyendo': 'Leyendo {total} ficha(s)…',
    'obras.fichaLeyendo': 'Leyendo…',
    'obras.fichaNoSeLeyo': 'No se pudo leer esta ficha.',
    'obras.fichaSinNombre': 'Sin nombre en la ficha',
    'obras.fichaCamposLeidos': '{total} campo(s) leídos del papel:',
    'obras.fichaDudas': 'No se ha entendido:',
    'obras.fichaRevisar': 'Repasar y dar de alta',
    'obras.campoNombre': 'Nombre',
    'obras.campoDireccion': 'Dirección',
    'obras.campoCp': 'Código postal',
    'obras.campoMunicipio': 'Municipio',
    'obras.campoZona': 'Zona',
    'obras.campoTipo': 'Tipo de proyecto',
    'obras.campoFase': 'Fase',
    'obras.campoProgreso': 'Progreso',
    'obras.campoFin': 'Finalización',
    'obras.campoConfianza': 'Confianza',
    'obras.campoComentario': 'Comentario',
    'obras.campoEtapa': 'Etapa',
    'obras.campoResponsable': 'Responsable',
    'obras.campoValor': 'Valor de mercado',
    'obras.campoContactos': 'Contactos',
    'obras.promotor': 'Promotor',
    'obras.promotorEjemplo': 'Ej.: Promociones Son Vida SL',
    'obras.guardando': 'Guardando…',
    'fotos.adjuntar': 'Adjuntar fotos (JPG o PNG, una o varias)',
    'fotos.altaNota': 'Se suben al guardar la oportunidad, con la fecha de hoy y tu nombre. Así, cuando se añadan fotos dentro de unos meses, se podrá comparar cuánto ha avanzado la obra.',
    'fotos.alGuardar': 'Se sube al guardar',
    'fotos.guardandoConFotos': 'Guardando y subiendo fotos…',
    'fotos.noSubieron': 'La oportunidad se guardó, pero {total} foto(s) no se pudieron subir. Añádelas desde la pestaña Fotos.',
    'obras.simularRol': 'Simular rol',
    'obras.rolDireccion': 'Direccion',
    'obras.rolComercial': 'Comercial',
    'obras.rolOtro': 'Cliente o proveedor',
    'obras.soloLectura': 'Solo lectura: esta oportunidad no esta asignada a ti.',
    'nivelIncidencia.1': 'Urgencia',
    'nivelIncidencia.2': 'Prioritaria',
    'nivelIncidencia.3': 'Programable',
    'nivelIncidencia.4': 'Mejora estética',
    'estadoIncidencia.OPEN': 'Abierta',
    'estadoIncidencia.IN_PROGRESS': 'En curso',
    'estadoIncidencia.CLOSED': 'Cerrada',
    'estadoIncidencia.CANCELLED': 'Anulada',
    'tipoDocumento.CONTRATO': 'Contrato',
    'tipoDocumento.SEGURO': 'Seguro',
    'tipoDocumento.GARANTIA': 'Garantía',
    'tipoDocumento.FACTURA': 'Factura',
    'tipoDocumento.OTRO': 'Otro',
    'areaMant.GESTION': 'Gestión',
    'frecuencia.SEMANAL': 'Semanal',
    'frecuencia.QUINCENAL': 'Quincenal',
    'frecuencia.MENSUAL': 'Mensual',
    'frecuencia.TRIMESTRAL': 'Trimestral',
    'frecuencia.SEMESTRAL': 'Semestral',
    'frecuencia.ANUAL': 'Anual',
    'frecuencia.PERSONALIZADA': 'Personalizada',
    'ficha.genera': 'Genera',
    'ficha.antelacion': '{total}d antelación',
    'estadoEstancia.PREVISTA': 'Prevista',
    'estadoEstancia.EN_CURSO': 'En curso',
    'estadoEstancia.FINALIZADA': 'Finalizada',
    'estadoEstancia.CANCELADA': 'Cancelada',
    'ficha.resumen': 'Resumen',
    'ficha.buscarIncidencia': 'Buscar incidencia',
    'ficha.incidencias': 'Incidencias',
    'ficha.visitas': 'Visitas',
    'ficha.mantenimiento': 'Mantenimiento',
    'ficha.proveedores': 'Proveedores',
    'ficha.gastos': 'Gastos',
    'ficha.contratos': 'Contratos',
    'ficha.historial': 'Historial',
    'ficha.proximaVisita': 'Próxima visita',
    'ficha.ultimaVisita': 'Última visita',
    'ficha.visitasVencidas': '{total} visitas vencidas',
    'ficha.sinVisitas': 'Todavía sin visitas',
    'ficha.incidenciasActivas': 'Incidencias activas',
    'ficha.gastoAcumulado': 'Gasto acumulado',
    'ficha.horasCol': 'Horas',
    'ficha.horasImputadas': '{total} h imputadas',
    'ficha.estancias': 'Estancias del cliente',
    'ficha.confirmarQuitarEstancia': '¿Quitar la estancia {cuando}? Se anula, no se borra.',
    'ficha.sinEstancias': 'Sin estancias registradas.',
    'ficha.llegada': 'Llegada',
    'ficha.salida': 'Salida',
    'ficha.huesped': 'Huésped',
    'ficha.registrarEstancia': 'Registrar estancia',
    'ficha.fotos': 'Fotos de la propiedad',
    'ficha.sinFotos': 'Sin fotos todavía.',
    'ficha.anadirFoto': 'Añadir foto',
    'ficha.urlFoto': 'Dirección de la imagen',
    'ficha.fotoPorUrl': 'Por ahora se guarda la dirección de la imagen; la subida de ficheros es una pieza aparte.',
    'ficha.tarifasEquipo': 'Tarifas del equipo',
    'ficha.rol': 'Rol',
    'ficha.porHora': 'EUR/hora',
    'ficha.fijaMensual': 'Tarifa fija/mes',
    'ficha.tarifaPrioridad': 'La tarifa fija mensual tiene prioridad sobre la de por hora.',
    'ficha.mantenimientoExplicacion': 'El preventivo se repite con una cadencia; al marcarlo hecho, la próxima fecha se calcula sola.',
    'ficha.sinMantenimiento': 'Sin mantenimiento programado.',
    'ficha.cadaDias': 'cada {total} días',
    'ficha.puntual': 'puntual',
    'ficha.proxima': 'Próxima',
    'ficha.marcarHecho': 'Marcar hecho',
    'ficha.concepto': 'Concepto',
    'ficha.cadenciaDias': 'Cadencia (días)',
    'ficha.anadirMantenimiento': 'Añadir mantenimiento',
    'ficha.proveedoresExplicacion': 'Los proveedores habituales de esta propiedad, para no buscarlos cada vez.',
    'ficha.sinProveedores': 'Sin proveedores vinculados.',
    'ficha.vincularProveedor': 'Vincular proveedor',
    'ficha.vincular': 'Vincular',
    'ficha.desvincular': 'Desvincular',
    'ficha.gastosMesActual': 'Gastos imputados a esta propiedad en el mes en curso.',
    'acceso.lema': 'Todo supervisado por nuestro equipo y bajo un mismo estándar de calidad.',
    'acceso.sub': 'Gestión integral de propiedades — visitas, incidencias y patrimonio bajo una sola llave.',
    'acceso.bienvenido': 'Bienvenido de nuevo',
    'acceso.entrar': 'Iniciar sesión',
    'areaMant.INTERIOR': 'Interior',
    'areaMant.EXTERIOR': 'Exterior',
    'areaMant.SISTEMAS': 'Sistemas',
    'areaMant.PISCINA': 'Piscina',
    'areaMant.JARDIN': 'Jardín',
    'areaMant.OTRO': 'Otro',
    'estadoEvento.PREVISTA': 'Abierta',
    'estadoEvento.EN_CURSO': 'En curso',
    'estadoEvento.HECHA': 'Cerrada',
    'estadoEvento.CANCELADA': 'Cancelada',
    'ficha.ocupada': 'Ocupada',
    'ficha.casaVacia': 'Casa vacía',
    'ficha.sinSalida': 'Sin fecha de salida',
    'ficha.confirmarQuitarDocumento': '¿Quitar «{titulo}»? El fichero se borra con él.',
    'visita.enCursoNoSeQuita': 'Esa visita se está recorriendo ahora mismo. Termínala o abandónala y después quítala de la agenda.',
    'ajustes.categoriaRepetida': 'Ya existe una categoría con ese nombre.',
    'ajustes.categoriaEnUso': 'Esa categoría tiene gastos apuntados: desactívala en vez de borrarla, y los gastos antiguos seguirán contando.',
    'ajustes.categoriaDelSistema': 'Esa categoría es del sistema: se puede renombrar y desactivar, pero no borrar.',
    'estancia.enCurso': 'Esa estancia está en curso.',
    'visita.exigeFoto': 'Ese punto pide una foto: haz la foto y después márcalo.',
    'visita.pideFoto': 'Pide foto',
    'visita.anadirFoto': 'Foto',
    'visita.faltanFotos': 'No puedes cerrar la visita: quedan puntos que piden foto sin resolver. Haz la foto, o márcalos «No aplica».',
    'visita.hacerFoto': 'Hacer la foto',
    'visita.reabrir': 'Reabrir la visita',
    'visita.reabrirPie': 'Para añadir o quitar fotos y corregir lo que se marcó.',
    'visita.subiendoFoto': 'Subiendo…',
    'visita.quitar': 'Quitar de la agenda',
    'visita.confirmarQuitar': '¿Quitar «{titulo}» de la agenda?',
    'interno.titulo': 'Interno',
    'interno.subtitulo': 'Gastos y horas del equipo, sin propiedad',
    'interno.subtituloPropio': 'Tu histórico de horas y gastos. Solo el tuyo.',
    'interno.total': 'Total gastado',
    'interno.registros': '{total} registros',
    'interno.pendientes': 'Pendientes de aprobar',
    'interno.pendientesPie': 'esperan decisión',
    'interno.sinContabilizar': 'Sin contabilizar',
    'interno.sinContabilizarPie': 'no pasados a contabilidad',
    'interno.horas': 'Horas',
    'interno.gastos': 'Gastos',
    'interno.categoria': 'Categoría',
    'interno.estado': 'Estado',
    'interno.todasCategorias': 'Todas las categorías',
    'interno.todosEstados': 'Todos los estados',
    'interno.vacio': 'No hay registros.',
    'interno.fecha': 'Fecha',
    'gasto.factura': 'Factura',
    'gasto.verFactura': 'Ver la factura del gasto',
    'gasto.sinFactura': 'Este gasto no tiene ninguna factura adjunta. Súbela aquí.',
    'gasto.adjuntarFactura': 'Subir la factura (imagen o PDF)',
    'gasto.adjuntarOtra': 'Añadir otra (imagen o PDF)',
    'gasto.formatosFactura': 'JPG, PNG, HEIC o PDF. Hasta 20 MB.',
    'gasto.subiendo': 'Subiendo…',
    'gasto.noSeSubio': 'No se pudo subir la factura. Vuelve a intentarlo.',
    'gasto.abrirAparte': 'Abrir en otra pestaña',
    'carga.editar': 'Editar',
    'carga.eliminar': 'Quitar',
    'carga.acciones': 'Acciones',
    'carga.editarGasto': 'Editar el gasto',
    'carga.editarHoras': 'Editar la carga de horas',
    'carga.confirmarGasto': '¿Quitar «{concepto}»? Dejará de contar en el mes y en lo que se factura.',
    'carga.confirmarHoras': '¿Quitar esta carga de {horas}? Dejará de contar en el mes y en el pago.',
    'carga.guardar': 'Guardar los cambios',
    'carga.noSeGuardo': 'No se pudieron guardar los cambios.',
    'carga.noSeQuito': 'No se pudo quitar.',
    'carga.horas': 'Horas',
    'carga.sinPropiedad': 'Interno (sin propiedad)',
    'interno.ambito': 'Qué cargas mostrar',
    'interno.ambitoInterno': 'Del equipo (sin casa)',
    'interno.ambitoCasas': 'Cargadas a casas',
    'interno.ambitoTodo': 'Todas',
    'interno.propiedad': 'Casa',
    'fotos.titulo': 'Fotos',
    'fotos.subir': 'Subir fotos',
    'fotos.subiendo': 'Subiendo {total} fichero(s)…',
    'fotos.noSeSubio': 'No se pudo subir «{fichero}».',
    'fotos.quitar': 'Quitar la foto',
    'fotos.confirmarQuitar': '¿Quitar esta foto? No se puede deshacer.',
    'fotos.noSeQuito': 'No se pudo quitar la foto.',
    'fotos.sinAutor': 'Sin autor',
    'fotos.vacio': 'Todavía no hay ninguna foto.',
    'fotos.vacioPuede': 'Todavía no hay ninguna foto. Sube la primera con el botón de arriba.',
    'fotos.obra': 'Fotos de la obra',
    'fotos.obraNota': 'Cada foto queda con quién la subió y cuándo: así se ve cómo avanza la obra comparándolas.',
    'fotos.tarea': 'Imágenes',
    'interno.concepto': 'Concepto',
    'interno.beneficiario': 'Beneficiario',
    'interno.contab': 'Contab.',
    'interno.contabSi': 'Sí',
    'interno.contabNo': 'No',
    'interno.importe': 'Importe',
    'interno.persona': 'Persona',
    'interno.tipo': 'Tipo',
    'interno.descripcion': 'Descripción',
    'interno.horasCol': 'Horas',
    'estadoGasto.PENDIENTE_APROBACION': 'Pend. aprobar',
    'estadoGasto.APROBADO': 'Aprobado',
    'estadoGasto.RECHAZADO': 'Rechazado',
    'estadoGasto.PAGADO': 'Pagado',
    'categoriaGasto.LOGISTICA': 'Logística',
    'categoriaGasto.COMPRA': 'Compra',
    'categoriaGasto.OTRO': 'Otros',
    'categoriaGasto.MARKETING': 'Marketing',
    'categoriaGasto.VEHICULOS': 'Vehículos / combustible',
    'categoriaGasto.PROPERTY_MANAGEMENT': 'Costes Property Management',
    'categoriaGasto.OFICINA': 'Oficina',
    'categoriaGasto.PROVEEDORES_CLIENTES': 'Proveedores vinculados a clientes',
    'categoriaGasto.EQUIPO': 'Equipo',
    'categoriaGasto.GASTOS_GENERALES': 'Gastos generales',
    'categoriaGasto.REAL_ESTATE': 'Costes Real Estate',
    'categoriaGasto.SOFTWARE': 'Software',
    'categoriaGasto.SERVICIOS': 'Servicios',
    'categoriaGasto.RECUPERABLES': 'Costes recuperables',
    'categoriaGasto.LIMPIEZA': 'Limpieza',
    'categoriaGasto.GESTORIA': 'Gestoría / legal / admin.',
    'categoriaGasto.OTROS_DIRECTOS': 'Otros costes directos',
    'tipoHora.GESTION': 'Gestión',
    'tipoHora.OTRO': 'Otro',
    'tipoHora.MANTENIMIENTO': 'Mantenimiento',
    'tipoHora.LIMPIEZA': 'Limpieza',
    'tipoHora.OBRA': 'Obra',
    'tipoHora.ADMINISTRACION': 'Administración',
    'tipoHora.COMERCIAL': 'Comercial',
    'tipoHora.DESPLAZAMIENTO': 'Desplazamiento',
    'estadoPropiedad.ONBOARDING': 'En alta',
    'estadoPropiedad.ACTIVE': 'Activa',
    'estadoPropiedad.SUSPENDED': 'Suspendida',
    'estadoPropiedad.INTERNAL_DEMO': 'Interna o demostración',
    'estadoPropiedad.ARCHIVED': 'Archivada',
    'requisito.DIRECCION': 'Dirección',
    'requisito.ZONA': 'Zona',
    'requisito.PROPIETARIO': 'Al menos un propietario',
    'requisito.CONTRATO': 'Contrato de gestión vigente',
    'requisito.CLIENTE_FACTURACION': 'Cliente de facturación',
    'requisito.TARIFA': 'Tarifa vigente',
    'requisito.NIO_VALIDADA': 'Evaluación operativa validada',
    'requisito.RESPONSABLE_INTERNO': 'Responsable interno',
    'semaforo.VERDE': 'Al día',
    'semaforo.AMARILLO': 'Atención',
    'semaforo.ROJO': 'Riesgo',
    'rol.DIRECTOR': 'Dirección',
    'rol.MANAGER': 'Manager',
    'rol.PROVEEDOR': 'Proveedor',
    'rol.CLIENTE': 'Cliente',
    'rol.PROMOTOR': 'Promotor',
    'portal.soloMirar': 'Estás viendo esta propiedad como observador: puedes consultarlo todo, pero no registrar ni escribir nada.',
    'rol.CAPTADOR': 'Captador',
    'crm.pipelines': 'Pipelines',
    'crm.pipelinesPie': 'El embudo comercial de siempre: oportunidades por etapa.',
    'crm.obras': 'Oportunidades de obra',
    'crm.obrasPie': 'Obras en marcha que pueden acabar siendo cartera.',
    'pap.titulo': 'Puerta a puerta',
    'pap.sub': 'Lo que se recorre a pie: qué calles hicimos y cómo nos fue.',
    'pap.registrar': 'Registrar puerta',
    'pap.nuevaPuerta': 'Nueva puerta',
    'pap.estoyAqui': 'Estoy aquí',
    'pap.ubicando': 'Buscando la dirección…',
    'pap.sinGps': 'Este dispositivo no da la ubicación. Escribe la dirección.',
    'pap.noSePudoUbicar': 'No se pudo leer la ubicación. Escribe la dirección.',
    'pap.direccion': 'Dirección',
    'pap.zona': 'Zona',
    'pap.municipio': 'Municipio',
    'pap.codigoPostal': 'Código postal',
    'pap.situarTitulo': 'Dónde está exactamente',
    'pap.situarPie': 'Toca el mapa o arrastra la chincheta hasta la casa. Se guarda al pulsar Guardar.',
    'pap.atendieron': '¿Nos atendieron?',
    'pap.queDijeron': '¿Qué nos dijeron?',
    'pap.respuestaOtra': 'Escríbelo con tus palabras',
    'pap.contacto': 'Nombre del contacto',
    'pap.contactoPie': 'Opcional',
    'pap.telefono': 'Teléfono',
    'pap.notas': 'Notas',
    'pap.material': 'Material entregado',
    'pap.fotos': 'Fotos',
    'pap.fotosPie': 'La fachada, y lo que esté descuidado: jardín, portón, piscina.',
    'pap.hacerFoto': 'Hacer foto',
    'pap.anadirFoto': 'Añadir foto',
    'pap.subiendo': 'Subiendo…',
    'pap.fotosElegidas': '{total} fotos listas',
    'pap.fotosGuardadas': '{total} fotos guardadas en la ficha',
    'pap.fotosPerdidas': '{total} fotos no se pudieron subir. La puerta quedó registrada; añádelas desde su ficha.',
    'pap.guardar': 'Guardar y seguir',
    'pap.guardando': 'Guardando…',
    'pap.guardada': 'Puerta registrada',
    'pap.siguiente': 'Siguiente puerta',
    'pap.terminar': 'Terminar',
    'pap.mapa': 'Mapa de lo recorrido',
    'pap.vista.mapa': 'Mapa',
    'pap.vista.zonas': 'Zonas',
    'pap.vista.lista': 'Lista',
    'pap.buscar': 'Buscar calle, zona o nombre',
    'pap.todas': 'Todas',
    'pap.estadoTitulo': 'Estado',
    'pap.estado.ATENDIO': 'Atendieron',
    'pap.estado.NO_ATENDIO': 'No atendieron',
    'pap.estado.SEGUIMIENTO': 'Seguimiento',
    'pap.estado.DESCARTADA': 'Descartada',
    'pap.estado.CLIENTE': 'Ya es cliente',
    'pap.respuesta.YA_TIENE_GESTOR': 'Ya tiene quien se la gestione',
    'pap.respuesta.NO_INTERESA': 'No le interesa',
    'pap.respuesta.DEJA_INFORMACION': 'Que le deje información',
    'pap.respuesta.LLAMA_MAS_ADELANTE': 'Que llame más adelante',
    'pap.respuesta.SEGUNDA_RESIDENCIA': 'Es segunda residencia',
    'pap.respuesta.NO_ES_PROPIETARIO': 'No es el propietario',
    'pap.respuesta.QUIERE_INFORMACION': 'Quiere información',
    'pap.respuesta.OTRA': 'Otra',
    'pap.material.FLYER': 'Flyer',
    'pap.material.TARJETA': 'Tarjeta',
    'pap.material.AMBOS': 'Ambos',
    'pap.material.NINGUNO': 'Nada',
    'pap.seguimientos': 'Seguimientos y tareas',
    'pap.nuevoSeguimiento': 'Qué hay que hacer aquí',
    'pap.sinSeguimientos': 'Nada pendiente en esta puerta.',
    'pap.historial': 'Historial',
    'pap.sinHistorial': 'Sin movimientos todavía.',
    'pap.zonasRecorridas': 'Zonas recorridas',
    'pap.zonaResumen': '{puertas} puertas · {atendidas} con respuesta',
    'pap.vacio': 'Todavía no hay ninguna puerta registrada.',
    'pap.sinEnEsteFiltro': 'No hay ninguna aquí.',
    'pap.noSeCargaron': 'No se pudieron cargar las puertas.',
    'pap.confirmarQuitar': '¿Quitar esta puerta? No se puede deshacer.',
    'party.titulo': 'Personas y empresas',
    'party.vacio': 'Todavía no hay personas ni empresas.',
    'party.nueva': 'Nueva persona o empresa',
    'party.editar': 'Editar',
    'party.tipo': 'Tipo',
    'party.pais': 'País (ISO)',
    'party.nif': 'NIF o documento fiscal',
    'party.nifSoloFacturacion': 'Solo necesario si va a facturar',
    'party.direccionFacturacion': 'Dirección de facturación',
    'party.telefono': 'Teléfono',
    'party.PERSONA_FISICA': 'Persona física',
    'party.EMPRESA': 'Empresa',
    'party.COMUNIDAD_PROPIETARIOS': 'Comunidad de propietarios',
    'party.OTRA_ENTIDAD_JURIDICA': 'Otra entidad jurídica',
    'party.archivada': 'Esta ficha está archivada.',
    'party.datosFacturacionIncompletos': 'Faltan datos de facturación: NIF, correo o dirección de facturación.',
    'party.enUso': 'No se puede archivar: tiene contratos o relaciones vigentes.',
    'relacion.OWNER': 'Propietario',
    'relacion.PROMOTER': 'Promotora',
    'relacion.ASSET_MANAGER': 'Empresa gestora',
    'relacion.AUTHORIZED_CONTACT': 'Contacto autorizado',
    'relacion.vacio': 'Todavía no hay ninguna relación.',
    'relacion.rol': 'Calidad en que interviene',
    'relacion.desde': 'Desde',
    'relacion.anadir': 'Añadir relación',
    'relacion.finalizar': 'Finalizar',
    'relacion.motivoFin': 'Motivo de finalización',
    'relacion.historicas': 'Relaciones anteriores',
    'contrato.titulo': 'Contrato de gestión',
    'contrato.vacio': 'Todavía no hay ningún contrato.',
    'contrato.DRAFT': 'Borrador',
    'contrato.ACTIVE': 'Vigente',
    'contrato.TERMINATED': 'Finalizado',
    'contrato.crear': 'Crear contrato',
    'contrato.desde': 'Fecha de inicio',
    'contrato.moneda': 'Moneda',
    'contrato.umbral': 'Umbral de aprobación del cliente',
    'contrato.tarifa': 'Tarifa',
    'contrato.importe': 'Importe',
    'contrato.importeOpcional': 'opcional: se toma la cuota sugerida',
    'contrato.modalidadTarifa': 'Modalidad de tarifa',
    'contrato.fijarTarifa': 'Fijar tarifa',
    'contrato.activar': 'Activar contrato',
    'contrato.congelada': 'importe congelado al activar',
    'contrato.historicos': 'Contratos anteriores',
    'contrato.finalizar': 'Finalizar contrato',
    'contrato.hasta': 'Fecha efectiva de fin',
    'contrato.motivoFin': 'Motivo de finalización',
    'contrato.finalizarConsecuencias': 'El contrato queda finalizado en esa fecha y la vigencia de su tarifa se cierra el mismo día. Si la propiedad está activa, pasa a suspendida en la misma operación. No se borra nada: el contrato y su tarifa quedan en el histórico.',
    'contrato.clienteFacturacion': 'Cliente de facturación',
    'contrato.modalidad.MANUAL': 'Tarifa manual',
    'contrato.modalidad.NIO': 'Tarifa por nivel operativo',
    'contrato.tarifaCongelada': 'La tarifa de un contrato vigente está congelada.',
    'contrato.nioNoValidada': 'Una tarifa por nivel operativo exige una evaluación validada.',
    'contrato.nioDeOtraPropiedad': 'Esa evaluación pertenece a otra propiedad.',
    'contrato.estadoInvalido': 'El contrato no está en un estado que permita esta acción.',
    'contrato.sinPagador': 'Falta el cliente de facturación.',
    'contrato.sinTarifa': 'Falta la tarifa.',
    'propiedad.estadoSinCambio': 'La propiedad ya está en ese estado.',
    'propiedad.transicionNoPermitida': 'Ese cambio de estado no está permitido.',
    'propiedad.motivoObligatorio': 'Este cambio de estado requiere un motivo.',
    'propiedad.requisitosPendientes': 'Faltan requisitos para activar la propiedad.',
    'propiedad.incidenciasAbiertas': 'Hay incidencias abiertas: ciérralas o anúlalas antes.',
    'propiedad.noOperativa': 'La propiedad no está en servicio.',
    'propiedad.contratoVigente': 'Hay un contrato vigente: finalízalo antes de archivar.',
    'cicloVida.titulo': 'Ciclo de vida',
    'cicloVida.suspender': 'Suspender propiedad',
    'cicloVida.reactivar': 'Reactivar propiedad',
    'cicloVida.archivar': 'Archivar propiedad',
    'cicloVida.motivo': 'Motivo',
    'cicloVida.suspenderConsecuencias': 'Deja de estar en servicio. El contrato sigue vigente y su tarifa no se toca: suspender no lo finaliza. Se puede reactivar.',
    'cicloVida.reactivarConsecuencias': 'Vuelve al servicio. Exige contrato vigente y todos los requisitos cumplidos.',
    'cicloVida.archivarConsecuencias': 'Sale de la cartera de forma definitiva. Exige motivo, ninguna incidencia abierta y ningún contrato vigente. El histórico se conserva íntegro, pero esta ficha no vuelve a operarse.',
    'cicloVida.archivada': 'Propiedad archivada. Su historial se conserva íntegro. Puede restaurarse: vuelve al alta con el mismo expediente.',
    'cicloVida.restaurar': 'Restaurar propiedad',
    'cicloVida.restaurarConsecuencias': 'Vuelve al estado de alta con el mismo identificador, sus relaciones y todo su historial. No se crea una ficha nueva. Para volver a estar activa tendrá que cumplir de nuevo todos los requisitos y tener contrato vigente.',
    'nio.titulo': 'Evaluación operativa',
    'nio.vacio': 'Todavía no hay ninguna evaluación.',
    'nio.nueva': 'Nueva evaluación',
    'nio.sustituir': 'Sustituir por una nueva',
    'nio.editar': 'Editar borrador',
    'nio.validar': 'Validar',
    'nio.total': 'Total',
    'nio.yaHayBorrador': 'Ya existe un borrador para esta propiedad.',
    'nio.explicacion': 'Nivel de intensidad operativa: se calcula con seis factores puntuados de 1 a 5 y determina la cuota sugerida.',
    'nio.factorInvalido': 'Cada factor debe ser un número entero entre 1 y 5.',
    'nio.sinTablaBase': 'No hay ninguna tabla base configurada.',
    'nio.soloBorradorEditable': 'Solo se puede editar un borrador.',
    'nio.estadoInvalido': 'La evaluación no está en un estado que permita esta acción.',
    'nio.BORRADOR': 'Borrador',
    'nio.VALIDADA': 'Validada',
    'nio.SUSTITUIDA': 'Sustituida',
    'nio.cuotaSugerida': 'Cuota sugerida',
    'nio.factor.valorActivo': 'Valor del activo',
    'nio.factor.complejidadTecnica': 'Complejidad técnica',
    'nio.factor.frecuenciaUso': 'Frecuencia de uso',
    'nio.factor.exigenciaCliente': 'Nivel de exigencia del cliente',
    'nio.factor.exposicionClimatica': 'Exposición climática',
    'nio.factor.historialIntervencion': 'Historial e intervención',
    'incidencia.titulo': 'Incidencias',
    'incidencia.vacio': 'No hay incidencias.',
    'incidencia.crear': 'Registrar incidencia',
    'incidencia.descripcion': 'Descripción',
    'incidencia.acciones': 'Acciones',
    'incidencia.cerrar': 'Cerrar',
    'incidencia.anular': 'Anular',
    'incidencia.resolucion': 'Resolución',
    'incidencia.motivo': 'Motivo',
    'incidencia.OPEN': 'Abierta',
    'incidencia.IN_PROGRESS': 'En curso',
    'incidencia.CLOSED': 'Cerrada',
    'incidencia.CANCELLED': 'Anulada',
    'incidencia.estadoInvalido': 'La incidencia no está en un estado que permita esta acción.',
    'incidencia.sugerencia': 'La IA sugiere N{nivel} — {nombre}.',
    'incidencia.usarSugerencia': 'Usarlo',
    'incidencia.agregar': 'Agregar incidencia',
    'incidencia.tituloCampo': 'Título',
    'incidencia.area': 'Área',
    'incidencia.costeEstimado': 'Coste estimado (€)',
    'incidencia.fotos': 'Imágenes',
    'incidencia.anadirFotos': '📷 Añadir imágenes',
    'incidencia.quitarFoto': 'Quitar esta imagen',
    'incidencia.nivel': 'Nivel',
    'incidencia.nivel.1': 'Urgencia',
    'incidencia.nivel.2': 'Prioritaria',
    'incidencia.nivel.3': 'Programable',
    'incidencia.nivel.4': 'Mejora estética',
    'idioma.es': 'Español',
    'idioma.en': 'Inglés',
    'idioma.de': 'Alemán',
};
//# sourceMappingURL=es.js.map